const $aed308ccf2b638b0$export$4051a07651545597 = {
    menus: [
        {
            id: "chickenator-team",
            name: "Team Mighty Chickenator",
            burger_id: "chickenator",
            second_position: {
                optional: false,
                items: [
                    "harvest",
                    "caesar",
                    "stamina"
                ]
            },
            third_position: {
                optional: true,
                items: [
                    "pal",
                    "master",
                    "companion",
                    "nugget",
                    "renegate"
                ]
            },
            fourth_position: {
                optional: true,
                items: [
                    "bolt",
                    "guardian",
                    "dynamo",
                    "burst"
                ]
            },
            fifth_position: {
                optional: false,
                items: [
                    "water",
                    "soda",
                    "juice",
                    "beer",
                    "milkshake"
                ]
            },
            tags: [
                "menu"
            ]
        },
        {
            id: "protector-team",
            name: "Team Legendary Hamburger Protector",
            burger_included: true,
            burger_id: "protector",
            second_position: {
                optional: false,
                items: [
                    "pal",
                    "master",
                    "companion",
                    "nugget",
                    "renegate"
                ]
            },
            third_position: {
                optional: true,
                items: [
                    "harvest",
                    "caesar",
                    "stamina"
                ]
            },
            fourth_position: {
                optional: true,
                items: [
                    "bolt",
                    "guardian",
                    "dynamo",
                    "burst"
                ]
            },
            fifth_position: {
                optional: false,
                items: [
                    "water",
                    "soda",
                    "juice",
                    "beer",
                    "milkshake"
                ]
            },
            tags: [
                "menu"
            ]
        },
        {
            id: "vigilante-team",
            name: "Team Incredible Vegan Vigilante",
            burger_included: true,
            burger_id: "vigilante",
            second_position: {
                optional: false,
                items: [
                    "pal",
                    "nugget",
                    "harvest"
                ]
            },
            third_position: {
                optional: true,
                items: [
                    "bolt",
                    "guardian",
                    "dynamo",
                    "burst"
                ]
            },
            fourth_position: {
                optional: false,
                items: [
                    "water",
                    "soda",
                    "juice",
                    "beer"
                ]
            },
            tags: [
                "menu"
            ]
        },
        {
            id: "defender-team",
            name: "Team Classic Cheese Defender",
            burger_included: true,
            burger_id: "defender",
            second_position: {
                optional: false,
                items: [
                    "pal",
                    "master",
                    "companion",
                    "nugget",
                    "renegate"
                ]
            },
            third_position: {
                optional: true,
                items: [
                    "harvest",
                    "caesar",
                    "stamina"
                ]
            },
            fourth_position: {
                optional: true,
                items: [
                    "bolt",
                    "guardian",
                    "dynamo",
                    "burst"
                ]
            },
            fifth_position: {
                optional: false,
                items: [
                    "water",
                    "soda",
                    "juice",
                    "beer",
                    "milkshake"
                ]
            },
            tags: [
                "menu"
            ]
        },
        {
            id: "titan-team",
            name: "Team Epic Angus Titan",
            burger_included: true,
            burger_id: "titan",
            second_position: {
                optional: false,
                items: [
                    "pal",
                    "master",
                    "companion",
                    "nugget",
                    "renegate"
                ]
            },
            third_position: {
                optional: false,
                items: [
                    "water",
                    "soda",
                    "juice",
                    "beer",
                    "milkshake"
                ]
            },
            third_position: {
                optional: true,
                items: [
                    "harvest",
                    "caesar",
                    "stamina"
                ]
            },
            fourth_position: {
                optional: true,
                items: [
                    "bolt",
                    "guardian",
                    "dynamo",
                    "burst"
                ]
            },
            fifth_position: {
                optional: false,
                items: [
                    "water",
                    "soda",
                    "juice",
                    "beer",
                    "milkshake"
                ]
            },
            tags: [
                "menu"
            ]
        },
        {
            id: "fighter-team",
            name: "Team Supreme Chicken Fighter",
            burger_included: true,
            burger_id: "fighter",
            second_position: {
                optional: false,
                items: [
                    "pal",
                    "master",
                    "companion",
                    "nugget",
                    "renegate"
                ]
            },
            third_position: {
                optional: true,
                items: [
                    "harvest",
                    "caesar",
                    "stamina"
                ]
            },
            fourth_position: {
                optional: true,
                items: [
                    "bolt",
                    "guardian",
                    "dynamo",
                    "burst"
                ]
            },
            fifth_position: {
                optional: false,
                items: [
                    "water",
                    "soda",
                    "juice",
                    "beer",
                    "milkshake"
                ]
            },
            tags: [
                "menu"
            ]
        },
        {
            id: "burgerman-team",
            name: "Team Amazing Burger-Man",
            burger_included: true,
            burger_id: "burgerman",
            second_position: {
                optional: false,
                items: [
                    "pal",
                    "master",
                    "companion",
                    "nugget",
                    "renegate"
                ]
            },
            third_position: {
                optional: true,
                items: [
                    "harvest",
                    "caesar",
                    "stamina"
                ]
            },
            fourth_position: {
                optional: true,
                items: [
                    "bolt",
                    "guardian",
                    "dynamo",
                    "burst"
                ]
            },
            fifth_position: {
                optional: false,
                items: [
                    "water",
                    "soda",
                    "juice",
                    "beer",
                    "milkshake"
                ]
            },
            tags: [
                "menu"
            ]
        },
        {
            id: "bringer-team",
            name: "Team Fiery BBQ Bringer",
            burger_included: true,
            burger_id: "bringer",
            second_position: {
                optional: false,
                items: [
                    "pal",
                    "master",
                    "companion",
                    "nugget",
                    "renegate"
                ]
            },
            third_position: {
                optional: true,
                items: [
                    "harvest",
                    "caesar",
                    "stamina"
                ]
            },
            fourth_position: {
                optional: true,
                items: [
                    "bolt",
                    "guardian",
                    "dynamo",
                    "burst"
                ]
            },
            fifth_position: {
                optional: false,
                items: [
                    "water",
                    "soda",
                    "juice",
                    "beer",
                    "milkshake"
                ]
            },
            tags: [
                "menu"
            ]
        },
        {
            id: "knight-team",
            name: "Team Supreme Baconator Knight",
            burger_included: true,
            burger_id: "knight",
            second_position: {
                optional: false,
                items: [
                    "pal",
                    "master",
                    "companion",
                    "nugget",
                    "renegate"
                ]
            },
            third_position: {
                optional: true,
                items: [
                    "harvest",
                    "caesar",
                    "stamina"
                ]
            },
            fourth_position: {
                optional: true,
                items: [
                    "bolt",
                    "guardian",
                    "dynamo",
                    "burst"
                ]
            },
            fifth_position: {
                optional: false,
                items: [
                    "water",
                    "soda",
                    "juice",
                    "beer",
                    "milkshake"
                ]
            },
            tags: [
                "menu"
            ]
        },
        {
            id: "avenger-team",
            name: "Team Infernal Chili Avenger",
            burger_included: true,
            burger_id: "avenger",
            second_position: {
                optional: false,
                items: [
                    "pal",
                    "master",
                    "companion",
                    "nugget",
                    "renegate"
                ]
            },
            third_position: {
                optional: true,
                items: [
                    "harvest",
                    "caesar",
                    "stamina"
                ]
            },
            fourth_position: {
                optional: true,
                items: [
                    "bolt",
                    "guardian",
                    "dynamo",
                    "burst"
                ]
            },
            fifth_position: {
                optional: false,
                items: [
                    "water",
                    "soda",
                    "juice",
                    "beer",
                    "milkshake"
                ]
            },
            tags: [
                "menu"
            ]
        }
    ],
    items: [
        {
            id: "chickenator",
            type: "burger",
            name: "The Mighty Chickenator",
            description: "Embark on an adventure fit for a superhero with our legendary Hero Burgers! Crafted from the finest ingredients and bursting with flavor, each burger is a bold testament to culinary greatness, guaranteed to satisfy even the mightiest of appetites. Join us in the quest for savory victory\u2014try our Hero Burgers today!",
            ingredients: [
                "Chicken patty",
                "Tomatoes",
                "Lettuce",
                "Ketchup",
                "Mayo",
                "Sesam bun"
            ],
            price: 9.95,
            menu_price: 8.95,
            new: false,
            tags: [
                "burger",
                "chicken",
                "lactose"
            ],
            image: {
                small: {
                    jpg: "/img/burgers/256/the-mighty-chickenator-256-c.jpg",
                    webp: "/img/burgers/256/the-mighty-chickenator-256.webp"
                },
                medium: {
                    jpg: "/img/burgers/700/the-mighty-chickenator-700-c.jpg",
                    webp: "/img/burgers/700/the-mighty-chickenator-700.webp"
                },
                large: {
                    jpg: "/img/burgers/1200/the-mighty-chickenator-1200-c.jpg",
                    webp: "/img/burgers/1200/the-mighty-chickenator-1200.webp"
                },
                original: {
                    jpg: "/img/burgers/2048/the-mighty-chickenator-2048-c.jpg",
                    webp: "/img/burgers/2048/the-mighty-chickenator-2048.webp"
                }
            },
            weight: 290,
            nutrients_per_portion: {
                calories: 300,
                protein: 20,
                carbohydrates: 25,
                sugars: 3,
                fat: 13,
                fiber: 2,
                sodium: 0.3
            }
        },
        {
            id: "protector",
            type: "burger",
            name: "The Legendary Hamburger Protector",
            description: "Behold the Legendary Hamburger Protector, a towering masterpiece that stands as a beacon of savory delight. Crafted from premium beef, nestled between fluffy brioche buns, and adorned with a symphony of fresh toppings, this burger is a symbol of taste and justice, ensuring every bite is an epic adventure!",
            ingredients: [
                "Beef patty",
                "Onions",
                "Pickles",
                "Tomatoes",
                "Lettuce",
                "Ketchup",
                "Mayo",
                "Brioche bun"
            ],
            price: 10.95,
            menu_price: 9.95,
            new: false,
            tags: [
                "burger",
                "beef",
                "lactose"
            ],
            image: {
                small: {
                    jpg: "/img/burgers/256/the-legendary-hamburger-protector-256-c.jpg",
                    webp: "/img/burgers/256/the-legendary-hamburger-protector-256.webp"
                },
                medium: {
                    jpg: "/img/burgers/700/the-legendary-hamburger-protector-700-c.jpg",
                    webp: "/img/burgers/700/the-legendary-hamburger-protector-700.webp"
                },
                large: {
                    jpg: "/img/burgers/1200/the-legendary-hamburger-protector-1200-c.jpg",
                    webp: "/img/burgers/1200/the-legendary-hamburger-protector-1200.webp"
                },
                original: {
                    jpg: "/img/burgers/2048/the-legendary-hamburger-protector-2048-c.jpg",
                    webp: "/img/burgers/2048/the-legendary-hamburger-protector-2048.webp"
                }
            },
            weight: 330,
            nutrients_per_portion: {
                calories: 300,
                protein: 18,
                carbohydrates: 23,
                sugars: 4,
                fat: 12,
                fiber: 2,
                sodium: 0.4
            }
        },
        {
            id: "vigilante",
            type: "burger",
            name: "The Incredible Vegan Vigilante",
            description: "Unleash your inner hero with the Incredible Vegan Vigilante, a plant-powered burger that champions flavor and compassion. This burger fights for justice on your plate, proving that saving the world can be deliciously cruelty-free! Btw, haven't you heard yet? It's VEGAN!",
            ingredients: [
                "Vegan patty",
                "Lactose-free cheese",
                "Onions",
                "Pickles",
                "Tomatoes",
                "Lettuce",
                "Ketchup",
                "Vegan mayo",
                "Sesam bun"
            ],
            price: 11.95,
            menu_price: 10.95,
            new: false,
            tags: [
                "burger",
                "vegan"
            ],
            image: {
                small: {
                    jpg: "/img/burgers/256/the-incredible-vegan-vigilante-256-c.jpg",
                    webp: "/img/burgers/256/the-incredible-vegan-vigilante-256.webp"
                },
                medium: {
                    jpg: "/img/burgers/700/the-incredible-vegan-vigilante-700-c.jpg",
                    webp: "/img/burgers/700/the-incredible-vegan-vigilante-700.webp"
                },
                large: {
                    jpg: "/img/burgers/1200/the-incredible-vegan-vigilante-1200-c.jpg",
                    webp: "/img/burgers/1200/the-incredible-vegan-vigilante-1200.webp"
                },
                original: {
                    jpg: "/img/burgers/2048/the-incredible-vegan-vigilante-2048-c.jpg",
                    webp: "/img/burgers/2048/the-incredible-vegan-vigilante-2048.webp"
                }
            },
            weight: 320,
            nutrients_per_portion: {
                calories: 230,
                protein: 15,
                carbohydrates: 18,
                sugars: 3,
                fat: 10,
                fiber: 2,
                sodium: 0.3
            }
        },
        {
            id: "defender",
            type: "burger",
            name: "The Classic Cheese Defender",
            description: "Brace yourself for the ultimate comfort food experience with the Classic Cheese Defender\u2014a timeless masterpiece that pays homage to the iconic cheeseburger. Sink your teeth into juicy beef, layered with melted cheese and crisp lettuce, all hugged by soft brioche buns \u2014 a savory shield against hunger's onslaught!",
            ingredients: [
                "Beef patty",
                "Cheese",
                "Lettuce",
                "Pickles",
                "Ketchup",
                "Mayo",
                "Brioche bun"
            ],
            price: 10.95,
            menu_price: 9.95,
            new: false,
            tags: [
                "burger",
                "beef",
                "lactose"
            ],
            image: {
                small: {
                    jpg: "/img/burgers/256/the-classic-cheese-defender-256-c.jpg",
                    webp: "/img/burgers/256/the-classic-cheese-defender-256.webp"
                },
                medium: {
                    jpg: "/img/burgers/700/the-classic-cheese-defender-700-c.jpg",
                    webp: "/img/burgers/700/the-classic-cheese-defender-700.webp"
                },
                large: {
                    jpg: "/img/burgers/1200/the-classic-cheese-defender-1200-c.jpg",
                    webp: "/img/burgers/1200/the-classic-cheese-defender-1200.webp"
                },
                original: {
                    jpg: "/img/burgers/2048/the-classic-cheese-defender-2048-c.jpg",
                    webp: "/img/burgers/2048/the-classic-cheese-defender-2048.webp"
                }
            },
            weight: 340,
            nutrients_per_portion: {
                calories: 300,
                protein: 16,
                carbohydrates: 21,
                sugars: 4,
                fat: 16,
                fiber: 2,
                sodium: 0.5
            }
        },
        {
            id: "titan",
            type: "burger",
            name: "The Epic Angus Titan",
            description: "Prepare for a taste sensation like no other with the Epic Angus Titan - a burger of monumental proportions, forged from the finest Angus beef. With each bite, savor the rich, smoky flavor of premium beef, elevated by a symphony of fresh toppings - a true titan among burgers, destined for greatness!",
            ingredients: [
                "Angus beef",
                "Tomatoes",
                "Lettuce",
                "Pickles",
                "Red onions",
                "Mayo",
                "Brioche bun"
            ],
            price: 12.95,
            menu_price: 11.95,
            new: false,
            tags: [
                "burger",
                "beef",
                "lactose"
            ],
            image: {
                small: {
                    jpg: "/img/burgers/256/the-epic-angus-titan-256-c.jpg",
                    webp: "/img/burgers/256/the-epic-angus-titan-256.webp"
                },
                medium: {
                    jpg: "/img/burgers/700/the-epic-angus-titan-700-c.jpg",
                    webp: "/img/burgers/700/the-epic-angus-titan-700.webp"
                },
                large: {
                    jpg: "/img/burgers/1200/the-epic-angus-titan-1200-c.jpg",
                    webp: "/img/burgers/1200/the-epic-angus-titan-1200.webp"
                },
                original: {
                    jpg: "/img/burgers/2048/the-epic-angus-titan-2048-c.jpg",
                    webp: "/img/burgers/2048/the-epic-angus-titan-2048.webp"
                }
            },
            weight: 390,
            nutrients_per_portion: {
                calories: 320,
                protein: 22,
                carbohydrates: 23,
                sugars: 4,
                fat: 17,
                fiber: 2,
                sodium: 0.4
            }
        },
        {
            id: "fighter",
            type: "burger",
            name: "The Supreme Chicken Fighter",
            description: "Join the battle against blandness with the Supreme Chicken Fighter, a grilled chicken burger that reigns supreme in flavor and satisfaction. Sink your teeth into tender, juicy chicken breast, grilled to perfection and nestled between soft ciabatta buns, ready to conquer any hunger with its savory charm!",
            ingredients: [
                "Grilled chicken",
                "Cheese",
                "Red peppers",
                "Rucola",
                "Ketchup",
                "Ciabatta bun"
            ],
            price: 10.55,
            menu_price: 9.55,
            new: false,
            tags: [
                "burger",
                "chicken",
                "lactose"
            ],
            image: {
                small: {
                    jpg: "/img/burgers/256/the-supreme-chicken-fighter-256-c.jpg",
                    webp: "/img/burgers/256/the-supreme-chicken-fighter-256.webp"
                },
                medium: {
                    jpg: "/img/burgers/700/the-supreme-chicken-fighter-700-c.jpg",
                    webp: "/img/burgers/700/the-supreme-chicken-fighter-700.webp"
                },
                large: {
                    jpg: "/img/burgers/1200/the-supreme-chicken-fighter-1200-c.jpg",
                    webp: "/img/burgers/1200/the-supreme-chicken-fighter-1200.webp"
                },
                original: {
                    jpg: "/img/burgers/2048/the-supreme-chicken-fighter-2048-c.jpg",
                    webp: "/img/burgers/2048/the-supreme-chicken-fighter-2048.webp"
                }
            },
            weight: 360,
            nutrients_per_portion: {
                calories: 200,
                protein: 24,
                carbohydrates: 15,
                sugars: 3,
                fat: 10,
                fiber: 2,
                sodium: 0.3
            }
        },
        {
            id: "burgerman",
            type: "burger",
            name: "The Amazing Burger-Man",
            description: "Step into the culinary metropolis with the Amazing Burger-Man\u2014a towering tribute to the iconic New Yorker. Featuring layers of premium beef, melted cheese, and a medley of fresh toppings, this burger swings into action to save your taste buds from boredom with each heroic bite!",
            ingredients: [
                "Beef patty",
                "Cheese",
                "Fried onions",
                "Pickles",
                "Lettuce",
                "Ketchup",
                "Mustard",
                "Brioche bun"
            ],
            price: 10.89,
            menu_price: 9.89,
            new: false,
            tags: [
                "burger",
                "beef",
                "lactose"
            ],
            image: {
                small: {
                    jpg: "/img/burgers/256/the-amazing-burger-man-256-c.jpg",
                    webp: "/img/burgers/256/the-amazing-burger-man-256.webp"
                },
                medium: {
                    jpg: "/img/burgers/700/the-amazing-burger-man-700-c.jpg",
                    webp: "/img/burgers/700/the-amazing-burger-man-700.webp"
                },
                large: {
                    jpg: "/img/burgers/1200/the-amazing-burger-man-1200-c.jpg",
                    webp: "/img/burgers/1200/the-amazing-burger-man-1200.webp"
                },
                original: {
                    jpg: "/img/burgers/2048/the-amazing-burger-man-2048-c.jpg",
                    webp: "/img/burgers/2048/the-amazing-burger-man-2048.webp"
                }
            },
            weight: 345,
            nutrients_per_portion: {
                calories: 300,
                protein: 15,
                carbohydrates: 20,
                sugars: 4,
                fat: 17,
                fiber: 2,
                sodium: 0.5
            }
        },
        {
            id: "bringer",
            type: "burger",
            name: "The Fiery BBQ Bringer",
            description: "Ignite your taste buds with the Fiery BBQ Bringer, a burger that brings the heat and the flavor in equal measure. Featuring succulent beef, smothered in tangy BBQ sauce, and crowned with crispy onions, this burger is a fiery force to be reckoned with\u2014a delicious explosion of taste that'll leave you craving more!",
            ingredients: [
                "Beef patty",
                "Lettuce",
                "Red onions",
                "Spicy jalape\xf1os",
                "BBQ sauce",
                "Brioche bun"
            ],
            price: 11.85,
            menu_price: 10.85,
            new: true,
            tags: [
                "burger",
                "beef",
                "spicy"
            ],
            image: {
                small: {
                    jpg: "/img/burgers/256/the-fiery-bbq-bringer-256-c.jpg",
                    webp: "/img/burgers/256/the-fiery-bbq-bringer-256.webp"
                },
                medium: {
                    jpg: "/img/burgers/700/the-fiery-bbq-bringer-700-c.jpg",
                    webp: "/img/burgers/700/the-fiery-bbq-bringer-700.webp"
                },
                large: {
                    jpg: "/img/burgers/1200/the-fiery-bbq-bringer-1200-c.jpg",
                    webp: "/img/burgers/1200/the-fiery-bbq-bringer-1200.webp"
                },
                original: {
                    jpg: "/img/burgers/2048/the-fiery-bbq-bringer-2048-c.jpg",
                    webp: "/img/burgers/2048/the-fiery-bbq-bringer-2048.webp"
                }
            },
            weight: 360,
            nutrients_per_portion: {
                calories: 350,
                protein: 20,
                carbohydrates: 24,
                sugars: 4,
                fat: 18,
                fiber: 2,
                sodium: 0.4
            }
        },
        {
            id: "knight",
            type: "burger",
            name: "The Supreme Baconator Knight",
            description: "Embark on a flavor quest with the Supreme Baconator Knight, a burger fit for a hero of legendary proportions. Featuring juicy beef, crispy bacon, creamy ranch dressing, and fresh veggies, this burger wields its savory sword with unmatched culinary prowess\u2014an epic feast fit for kings!",
            ingredients: [
                "Beef patty",
                "Roasted bacon",
                "Cheese",
                "Red onions",
                "Ranch dressing",
                "Brioche bun"
            ],
            price: 10.95,
            menu_price: 9.95,
            new: false,
            tags: [
                "burger",
                "beef",
                "lactose"
            ],
            image: {
                small: {
                    jpg: "/img/burgers/256/the-supreme-baconator-knight-256-c.jpg",
                    webp: "/img/burgers/256/the-supreme-baconator-knight-256.webp"
                },
                medium: {
                    jpg: "/img/burgers/700/the-supreme-baconator-knight-700-c.jpg",
                    webp: "/img/burgers/700/the-supreme-baconator-knight-700.webp"
                },
                large: {
                    jpg: "/img/burgers/1200/the-supreme-baconator-knight-1200-c.jpg",
                    webp: "/img/burgers/1200/the-supreme-baconator-knight-1200.webp"
                },
                original: {
                    jpg: "/img/burgers/2048/the-supreme-baconator-knight-2048-c.jpg",
                    webp: "/img/burgers/2048/the-supreme-baconator-knight-2048.webp"
                }
            },
            weight: 370,
            nutrients_per_portion: {
                calories: 400,
                protein: 25,
                carbohydrates: 20,
                sugars: 5,
                fat: 22,
                fiber: 2,
                sodium: 0.6
            }
        },
        {
            id: "avenger",
            type: "burger",
            name: "The Infernal Chili Avenger",
            description: "Brace yourself for a flavor inferno with the Infernal Chili Avenger, a burger that ignites your taste buds with its fiery chili cheese goodness. Featuring smoky beef, spicy chili, melted cheese, and all the fixings, this burger delivers a flavor explosion that'll leave you feeling like a culinary superhero!",
            ingredients: [
                "Beef patty",
                "Onions",
                "Lettuce",
                "Spicy jalape\xf1os",
                "Cheese sauce",
                "Sesam bun"
            ],
            price: 11.85,
            menu_price: 10.85,
            new: false,
            tags: [
                "burger",
                "beef",
                "spicy",
                "lactose"
            ],
            image: {
                small: {
                    jpg: "/img/burgers/256/the-infernal-chili-avenger-256-c.jpg",
                    webp: "/img/burgers/256/the-infernal-chili-avenger-256.webp"
                },
                medium: {
                    jpg: "/img/burgers/700/the-infernal-chili-avenger-700-c.jpg",
                    webp: "/img/burgers/700/the-infernal-chili-avenger-700.webp"
                },
                large: {
                    jpg: "/img/burgers/1200/the-infernal-chili-avenger-1200-c.jpg",
                    webp: "/img/burgers/1200/the-infernal-chili-avenger-1200.webp"
                },
                original: {
                    jpg: "/img/burgers/2048/the-infernal-chili-avenger-2048-c.jpg",
                    webp: "/img/burgers/2048/the-infernal-chili-avenger-2048.webp"
                }
            },
            weight: 365,
            nutrients_per_portion: {
                calories: 300,
                protein: 17,
                carbohydrates: 20,
                sugars: 4,
                fat: 15,
                fiber: 2,
                sodium: 0.4
            }
        },
        {
            id: "pal",
            type: "fingerfood",
            name: "Crispy Potato Pal",
            description: "Stand tall with the Crispy Potato Pal, a companion of unparalleled crunch and satisfaction. These golden fries, fried to perfection, accompany your meal like a loyal ally, ready to add a burst of flavor and texture to every heroic bite!",
            ingredients: [],
            price: 4.89,
            menu_price: 3.89,
            new: false,
            tags: [
                "fingerfood",
                "vegan"
            ],
            image: {
                small: {
                    jpg: "/img/fingerfood/256/crispy-potato-pal-256-c.jpg",
                    webp: "/img/fingerfood/256/crispy-potato-pal-256.webp"
                },
                medium: {
                    jpg: "/img/fingerfood/700/crispy-potato-pal-700-c.jpg",
                    webp: "/img/fingerfood/700/crispy-potato-pal-700.webp"
                },
                large: {
                    jpg: "",
                    webp: ""
                },
                original: {
                    jpg: "/img/fingerfood/2048/crispy-potato-pal-2048-c.jpg",
                    webp: "/img/fingerfood/2048/crispy-potato-pal-2048.webp"
                }
            },
            weight: 180,
            nutrients_per_portion: {
                calories: 200,
                protein: 3,
                carbohydrates: 30,
                sugars: 1,
                fat: 15,
                fiber: 2,
                sodium: 0.3
            }
        },
        {
            id: "master",
            type: "fingerfood",
            name: "Winged Master",
            description: "Take flight with the Winged Master, a sidekick that soars above the rest with its bold flavors and irresistible crunch. These succulent chicken wings, seasoned to perfection and coated in tangy sauce, are the ultimate wingman for any mealtime adventure!",
            ingredients: [],
            price: 6.85,
            menu_price: 5.85,
            new: false,
            tags: [
                "fingerfood",
                "chicken"
            ],
            image: {
                small: {
                    jpg: "/img/fingerfood/256/winged-master-256-c.jpg",
                    webp: "/img/fingerfood/256/winged-master-256.webp"
                },
                medium: {
                    jpg: "/img/fingerfood/700/winged-master-700-c.jpg",
                    webp: "/img/fingerfood/700/winged-master-700.webp"
                },
                large: {
                    jpg: "",
                    webp: ""
                },
                original: {
                    jpg: "/img/fingerfood/2048/winged-master-2048-c.jpg",
                    webp: "/img/fingerfood/2048/winged-master-2048.webp"
                }
            },
            weight: 320,
            nutrients_per_portion: {
                calories: 250,
                protein: 20,
                carbohydrates: 8,
                sugars: 1,
                fat: 20,
                fiber: 0,
                sodium: 0.5
            }
        },
        {
            id: "companion",
            type: "fingerfood",
            name: "Nugget Companion",
            description: "Join forces with the Nugget Companion, a sidekick that brings a touch of whimsy and flavor to every meal. These crispy chicken nuggets, tender and delicious, stand by your side like a loyal friend, ready to add a dose of fun and satisfaction to your culinary escapades!",
            ingredients: [],
            price: 5.89,
            menu_price: 4.89,
            new: false,
            tags: [
                "fingerfood",
                "chicken"
            ],
            image: {
                small: {
                    jpg: "/img/fingerfood/256/nugget-companion-256-c.jpg",
                    webp: "/img/fingerfood/256/nugget-companion-256.webp"
                },
                medium: {
                    jpg: "/img/fingerfood/700/nugget-companion-700-c.jpg",
                    webp: "/img/fingerfood/700/nugget-companion-700.webp"
                },
                large: {
                    jpg: "",
                    webp: ""
                },
                original: {
                    jpg: "/img/fingerfood/2048/nugget-companion-2048-c.jpg",
                    webp: "/img/fingerfood/2048/nugget-companion-2048.webp"
                }
            },
            weight: 225,
            nutrients_per_portion: {
                calories: 200,
                protein: 10,
                carbohydrates: 16,
                sugars: 1,
                fat: 17,
                fiber: 2,
                sodium: 0.4
            }
        },
        {
            id: "nugget",
            type: "fingerfood",
            name: "Cruelty-Free Nugget",
            description: "Embrace compassion with the Cruelty-Free Nugget, a companion that champions flavor and kindness in equal measure. These vegan nuggets, crafted from wholesome ingredients and bursting with savory goodness, stand as a testament to the power of plant-based eating\u2014a delicious ally in your quest for culinary greatness!",
            ingredients: [],
            price: 6.89,
            menu_price: 5.89,
            new: false,
            tags: [
                "fingerfood",
                "vegan"
            ],
            image: {
                small: {
                    jpg: "/img/fingerfood/256/cruelty-free-nugget-256-c.jpg",
                    webp: "/img/fingerfood/256/cruelty-free-nugget-256.webp"
                },
                medium: {
                    jpg: "/img/fingerfood/700/cruelty-free-nugget-700-c.jpg",
                    webp: "/img/fingerfood/700/cruelty-free-nugget-700.webp"
                },
                large: {
                    jpg: "",
                    webp: ""
                },
                original: {
                    jpg: "/img/fingerfood/2048/cruelty-free-nugget-2048-c.jpg",
                    webp: "/img/fingerfood/2048/cruelty-free-nugget-2048.webp"
                }
            },
            weight: 200,
            nutrients_per_portion: {
                calories: 150,
                protein: 7,
                carbohydrates: 17,
                sugars: 1,
                fat: 11,
                fiber: 3,
                sodium: 0.4
            }
        },
        {
            id: "renegate",
            type: "fingerfood",
            name: "Ringed Renegade",
            description: "Prepare for a culinary revolution with the Ringed Renegade, a sidekick that defies convention and delights the senses. These crispy onion rings, golden and irresistible, add a touch of rebellion to any meal, standing as a symbol of flavor and fun in a world of ordinary sides!",
            ingredients: [],
            price: 4.55,
            menu_price: 3.55,
            new: false,
            tags: [
                "fingerfood"
            ],
            image: {
                small: {
                    jpg: "/img/fingerfood/256/ringed-renegate-256-c.jpg",
                    webp: "/img/fingerfood/256/ringed-renegate-256.webp"
                },
                medium: {
                    jpg: "/img/fingerfood/700/ringed-renegate-700-c.jpg",
                    webp: "/img/fingerfood/700/ringed-renegate-700.webp"
                },
                large: {
                    jpg: "",
                    webp: ""
                },
                original: {
                    jpg: "/img/fingerfood/2048/ringed-renegate-2048-c.jpg",
                    webp: "/img/fingerfood/2048/ringed-renegate-2048.webp"
                }
            },
            weight: 260,
            nutrients_per_portion: {
                calories: 250,
                protein: 2,
                carbohydrates: 25,
                sugars: 2,
                fat: 5,
                fiber: 2,
                sodium: 0.4
            }
        },
        {
            id: "harvest",
            type: "salad",
            name: "Plant-Powered Harvest",
            description: "A vegan salad packed with nutrient-rich vegetables to fortify your body and mind.",
            ingredients: [
                "Lettuce leafs",
                "Cherry tomatoes",
                "Carrots",
                "Cucumbers",
                "Sunflower seeds",
                "Balsamic dressing"
            ],
            price: 4.89,
            menu_price: 3.89,
            new: false,
            tags: [
                "salad",
                "vegan"
            ],
            image: {
                small: {
                    jpg: "/img/salads/256/plant-powered-harvest-256-c.jpg",
                    webp: "/img/salads/256/plant-powered-harvest-256.webp"
                },
                medium: {
                    jpg: "/img/salads/700/plant-powered-harvest-700-c.jpg",
                    webp: "/img/salads/700/plant-powered-harvest-700.webp"
                },
                large: {
                    jpg: "",
                    webp: ""
                },
                original: {
                    jpg: "/img/salads/2048/plant-powered-harvest-2048-c.jpg",
                    webp: "/img/salads/2048/plant-powered-harvest-2048.webp"
                }
            },
            weight: 330,
            nutrients_per_portion: {
                calories: 100,
                protein: 2,
                carbohydrates: 10,
                sugars: 5,
                fat: 5,
                fiber: 3,
                sodium: 0.1
            }
        },
        {
            id: "caesar",
            type: "salad",
            name: "Caesar's Conqueror Crisp",
            description: "A Caesar salad with a heroic twist, featuring crisp romaine lettuce, tangy Caesar dressing, and savory toppings fit for a conqueror.",
            ingredients: [
                "Lettuce leafs",
                "Croutons",
                "Cheese",
                "Cherry tomatoes",
                "Caesar dressing"
            ],
            price: 5.65,
            menu_price: 4.65,
            new: false,
            tags: [
                "salad",
                "lactose"
            ],
            image: {
                small: {
                    jpg: "/img/salads/256/caesars-conqueror-crisp-256-c.jpg",
                    webp: "/img/salads/256/caesars-conqueror-crisp-256.webp"
                },
                medium: {
                    jpg: "/img/salads/700/caesars-conqueror-crisp-700-c.jpg",
                    webp: "/img/salads/700/caesars-conqueror-crisp-700.webp"
                },
                large: {
                    jpg: "",
                    webp: ""
                },
                original: {
                    jpg: "/img/salads/2048/caesars-conqueror-crisp-2048-c.jpg",
                    webp: "/img/salads/2048/caesars-conqueror-crisp-2048.webp"
                }
            },
            weight: 230,
            nutrients_per_portion: {
                calories: 150,
                protein: 7,
                carbohydrates: 10,
                sugars: 3,
                fat: 15,
                fiber: 2,
                sodium: 0.3
            }
        },
        {
            id: "stamina",
            type: "salad",
            name: "Chicken Stamina Salad",
            description: "A chicken salad fit for a champion, featuring tender chicken breast, crisp vegetables, and a dressing that reigns supreme.",
            ingredients: [
                "Chicken filet",
                "Lettuce leafs",
                "Cheese",
                "Cherry tomatoes",
                "Olive oil"
            ],
            price: 5.95,
            menu_price: 4.95,
            new: false,
            tags: [
                "salad",
                "chicken"
            ],
            image: {
                small: {
                    jpg: "/img/salads/256/chicken-stamina-salad-256-c.jpg",
                    webp: "/img/salads/256/chicken-stamina-salad-256.webp"
                },
                medium: {
                    jpg: "/img/salads/700/chicken-stamina-salad-700-c.jpg",
                    webp: "/img/salads/700/chicken-stamina-salad-700.webp"
                },
                large: {
                    jpg: "",
                    webp: ""
                },
                original: {
                    jpg: "/img/salads/2048/chicken-stamina-salad-2048-c.jpg",
                    webp: "/img/salads/2048/chicken-stamina-salad-2048.webp"
                }
            },
            weight: 275,
            nutrients_per_portion: {
                calories: 200,
                protein: 16,
                carbohydrates: 10,
                sugars: 3,
                fat: 10,
                fiber: 2,
                sodium: 0.2
            }
        },
        {
            id: "bolt",
            type: "dessert",
            name: "Fudgy Power Bolt",
            description: "Indulge in the Fudgy Power Bolt, a brownie bursting with chocolaty goodness that fuels you with the energy to conquer any challenge with its rich and decadent flavor!",
            ingredients: [],
            price: 4.89,
            menu_price: 3.89,
            new: false,
            tags: [
                "dessert"
            ],
            image: {
                small: {
                    jpg: "/img/desserts/256/the-fudgy-power-bolt-256-c.jpg",
                    webp: "/img/desserts/256/the-fudgy-power-bolt-256.webp"
                },
                medium: {
                    jpg: "/img/desserts/700/the-fudgy-power-bolt-700-c.jpg",
                    webp: "/img/desserts/700/the-fudgy-power-bolt-700.webp"
                },
                large: {
                    jpg: "",
                    webp: ""
                },
                original: {
                    jpg: "/img/desserts/2048/the-fudgy-power-bolt-2048-c.jpg",
                    webp: "/img/desserts/2048/the-fudgy-power-bolt-2048.webp"
                }
            },
            weight: 75,
            nutrients_per_portion: {
                calories: 400,
                protein: 6,
                carbohydrates: 45,
                sugars: 27,
                fat: 20,
                fiber: 3,
                sodium: 0.2
            }
        },
        {
            id: "guardian",
            type: "dessert",
            name: "Creamy Fortress Guardian",
            description: "Delight in the Creamy Fortress Guardian, a cheesecake masterpiece that fortifies your spirit with its velvety texture and rich flavors, granting you the strength to defend against any adversity!",
            ingredients: [],
            price: 5.38,
            menu_price: 4.38,
            new: false,
            tags: [
                "dessert",
                "lactose"
            ],
            image: {
                small: {
                    jpg: "/img/desserts/256/the-creamy-fortress-guardian-256-c.jpg",
                    webp: "/img/desserts/256/the-creamy-fortress-guardian-256.webp"
                },
                medium: {
                    jpg: "/img/desserts/700/the-creamy-fortress-guardian-700-c.jpg",
                    webp: "/img/desserts/700/the-creamy-fortress-guardian-700.webp"
                },
                large: {
                    jpg: "",
                    webp: ""
                },
                original: {
                    jpg: "/img/desserts/2048/the-creamy-fortress-guardian-2048-c.jpg",
                    webp: "/img/desserts/2048/the-creamy-fortress-guardian-2048.webp"
                }
            },
            weight: 90,
            nutrients_per_portion: {
                calories: 300,
                protein: 8,
                carbohydrates: 25,
                sugars: 20,
                fat: 20,
                fiber: 2,
                sodium: 0.2
            }
        },
        {
            id: "dynamo",
            type: "dessert",
            name: "Choco-Chip Dynamo",
            description: "Energize yourself with the Choco-Chip Dynamo, a chocolate cookie packed with sweet surprises and crunchy goodness, unleashing a burst of energy that propels you to superhero heights with every bite!",
            ingredients: [],
            price: 2.89,
            menu_price: 1.89,
            new: false,
            tags: [
                "dessert"
            ],
            image: {
                small: {
                    jpg: "/img/desserts/256/the-choco-chip-dynamo-256-c.jpg",
                    webp: "/img/desserts/256/the-choco-chip-dynamo-256.webp"
                },
                medium: {
                    jpg: "/img/desserts/700/the-choco-chip-dynamo-700-c.jpg",
                    webp: "/img/desserts/700/the-choco-chip-dynamo-700.webp"
                },
                large: {
                    jpg: "",
                    webp: ""
                },
                original: {
                    jpg: "/img/desserts/2048/the-choco-chip-dynamo-2048-c.jpg",
                    webp: "/img/desserts/2048/the-choco-chip-dynamo-2048.webp"
                }
            },
            weight: 75,
            nutrients_per_portion: {
                calories: 450,
                protein: 6,
                carbohydrates: 55,
                sugars: 40,
                fat: 25,
                fiber: 3,
                sodium: 0.3
            }
        },
        {
            id: "burst",
            type: "dessert",
            name: "Mighty Berry Burst",
            description: "Fuel your adventures with the Mighty Berry Burst, a muffin loaded with juicy berries and wholesome ingredients, empowering you with a burst of vitality and flavor that propels you forward on your heroic journey!",
            ingredients: [],
            price: 4.89,
            menu_price: 3.89,
            new: false,
            tags: [
                "dessert",
                "lactose"
            ],
            image: {
                small: {
                    jpg: "/img/desserts/256/the-mighty-berry-burst-256-c.jpg",
                    webp: "/img/desserts/256/the-mighty-berry-burst-256.webp"
                },
                medium: {
                    jpg: "/img/desserts/700/the-mighty-berry-burst-700-c.jpg",
                    webp: "/img/desserts/700/the-mighty-berry-burst-700.webp"
                },
                large: {
                    jpg: "",
                    webp: ""
                },
                original: {
                    jpg: "/img/desserts/2048/the-mighty-berry-burst-2048-c.jpg",
                    webp: "/img/desserts/2048/the-mighty-berry-burst-2048.webp"
                }
            },
            weight: 130,
            nutrients_per_portion: {
                calories: 250,
                protein: 4,
                carbohydrates: 40,
                sugars: 15,
                fat: 13,
                fiber: 3,
                sodium: 0.2
            }
        },
        {
            id: "water",
            type: "drink",
            name: "Sparkling Water",
            description: "Rejuvenate with the Bubbly Vitality Elixir!",
            ingredients: [],
            price: 2.59,
            menu_price: 1.59,
            new: false,
            tags: [
                "drink"
            ],
            image: {
                small: {
                    jpg: "/img/drinks/256/sparkling-water-256-c.jpg",
                    webp: "/img/drinks/256/sparkling-water-256.webp"
                },
                medium: {
                    jpg: "/img/drinks/700/sparkling-water-700-c.jpg",
                    webp: "/img/drinks/700/sparkling-water-700.webp"
                },
                large: {
                    jpg: "",
                    webp: ""
                },
                original: {
                    jpg: "",
                    webp: ""
                }
            },
            weight: 500,
            nutrients_per_portion: {
                calories: 0,
                protein: 0,
                carbohydrates: 0,
                sugars: 0,
                fat: 0,
                fiber: 0,
                sodium: 0
            }
        },
        {
            id: "soda",
            type: "drink",
            name: "Soda",
            description: "Energize yourself with the Fizzy Power Surge!",
            ingredients: [],
            price: 3.55,
            menu_price: 2.55,
            new: false,
            tags: [
                "drink"
            ],
            image: {
                small: {
                    jpg: "/img/drinks/256/soda-256-c.jpg",
                    webp: "/img/drinks/256/soda-256.webp"
                },
                medium: {
                    jpg: "/img/drinks/700/soda-700-c.jpg",
                    webp: "/img/drinks/700/soda-700.webp"
                },
                large: {
                    jpg: "",
                    webp: ""
                },
                original: {
                    jpg: "",
                    webp: ""
                }
            },
            weight: 500,
            nutrients_per_portion: {
                calories: 50,
                protein: 0,
                carbohydrates: 10,
                sugars: 10,
                fat: 0,
                fiber: 0,
                sodium: 0.02
            }
        },
        {
            id: "juice",
            type: "drink",
            name: "Juice",
            description: "Revitalize with the Fruit-Fueled Dynamo!",
            ingredients: [],
            price: 3.89,
            menu_price: 2.89,
            new: false,
            tags: [
                "drink"
            ],
            image: {
                small: {
                    jpg: "/img/drinks/256/juice-256-c.jpg",
                    webp: "/img/drinks/256/juice-256.webp"
                },
                medium: {
                    jpg: "/img/drinks/700/juice-700-c.jpg",
                    webp: "/img/drinks/700/juice-700.webp"
                },
                large: {
                    jpg: "",
                    webp: ""
                },
                original: {
                    jpg: "",
                    webp: ""
                }
            },
            weight: 500,
            nutrients_per_portion: {
                calories: 60,
                protein: 0,
                carbohydrates: 15,
                sugars: 15,
                fat: 0,
                fiber: 0,
                sodium: 0.01
            }
        },
        {
            id: "beer",
            type: "drink",
            name: "Beer",
            description: "Unwind with the Brewed Resilience Beverage!",
            ingredients: [],
            price: 5.59,
            menu_price: 4.59,
            new: false,
            tags: [
                "drink",
                "alcoholic"
            ],
            image: {
                small: {
                    jpg: "/img/drinks/256/beer-256-c.jpg",
                    webp: "/img/drinks/256/beer-256.webp"
                },
                medium: {
                    jpg: "/img/drinks/700/beer-700-c.jpg",
                    webp: "/img/drinks/700/beer-700.webp"
                },
                large: {
                    jpg: "",
                    webp: ""
                },
                original: {
                    jpg: "",
                    webp: ""
                }
            },
            weight: 500,
            nutrients_per_portion: {
                calories: 50,
                protein: 0,
                carbohydrates: 5,
                sugars: 15,
                fat: 0,
                fiber: 0,
                sodium: 0.01
            }
        },
        {
            id: "milkshake",
            type: "drink",
            name: "Milkshake",
            description: "Indulge in the Creamy Power Potion!",
            ingredients: [],
            price: 4.99,
            menu_price: 3.99,
            new: false,
            tags: [
                "drink",
                "lactose"
            ],
            image: {
                small: {
                    jpg: "/img/drinks/256/milkshake-256-c.jpg",
                    webp: "/img/drinks/256/milkshake-256.webp"
                },
                medium: {
                    jpg: "/img/drinks/700/milkshake-700-c.jpg",
                    webp: "/img/drinks/700/milkshake-700.webp"
                },
                large: {
                    jpg: "",
                    webp: ""
                },
                original: {
                    jpg: "",
                    webp: ""
                }
            },
            weight: 400,
            nutrients_per_portion: {
                calories: 250,
                protein: 5,
                carbohydrates: 30,
                sugars: 25,
                fat: 10,
                fiber: 0,
                sodium: 0.1
            }
        }
    ]
};


const $9dfdde2870d5f6f9$export$40efa604c66968ab = 5;
const $9dfdde2870d5f6f9$export$45039f329125d02c = 25;
const $9dfdde2870d5f6f9$export$5b4488fd1e9252aa = 15;
const $9dfdde2870d5f6f9$export$cbea70a2a3c167da = 60;
const $9dfdde2870d5f6f9$export$9d2732c5dba079a3 = "^[a-zA-Z\\u0080-\\u024F\\s]{2,64}$";
const $9dfdde2870d5f6f9$export$c924649278fd1cb6 = "^(\\+\\d{1,2}\\s?)?\\(?\\d{3,4}\\)?[\\s.\\-]?\\d{3}[\\s.\\-]?\\d{4}$";
const $9dfdde2870d5f6f9$export$c9d018dd9cdc54a3 = "[a-zA-Z\\s\\d\\-\\,\\.]{5,64}";
const $9dfdde2870d5f6f9$export$96cb3daae875a04d = "[a-zA-Z0-9\\s\\-\\/\\.]{0,16}";
const $9dfdde2870d5f6f9$export$baf0e4b816c68eb1 = "\\d{5}";
const $9dfdde2870d5f6f9$export$b85bbe1c93b6745e = "^([\\Da-zA-Z\\u0080-\\u024F]+(?:. |-| |'))*[\\Da-zA-Z\\u0080-\\u024F]{2,32}$";
const $9dfdde2870d5f6f9$export$702dd1129c4aa79 = "https://github.com/kstarostin/heroburger";



const $c9c3c560c3a94d63$export$6c5fa4acfd9b4c37 = function(deliveryAddress) {
    const invalidFields = [];
    if (!$c9c3c560c3a94d63$var$validateParameter(deliveryAddress.name, (0, $9dfdde2870d5f6f9$export$9d2732c5dba079a3))) invalidFields.push("name");
    if (!$c9c3c560c3a94d63$var$validateParameter(deliveryAddress.phone, (0, $9dfdde2870d5f6f9$export$c924649278fd1cb6))) invalidFields.push("phone");
    if (!$c9c3c560c3a94d63$var$validateParameter(deliveryAddress.street, (0, $9dfdde2870d5f6f9$export$c9d018dd9cdc54a3))) invalidFields.push("street");
    if (!$c9c3c560c3a94d63$var$validateParameter(deliveryAddress.apartment, (0, $9dfdde2870d5f6f9$export$96cb3daae875a04d))) invalidFields.push("apartment");
    if (!$c9c3c560c3a94d63$var$validateParameter(deliveryAddress.zip, (0, $9dfdde2870d5f6f9$export$baf0e4b816c68eb1))) invalidFields.push("zip");
    if (!$c9c3c560c3a94d63$var$validateParameter(deliveryAddress.town, (0, $9dfdde2870d5f6f9$export$b85bbe1c93b6745e))) invalidFields.push("town");
    return invalidFields;
};
const $c9c3c560c3a94d63$var$validateParameter = function(field, regex) {
    const regexp = new RegExp(regex);
    return regexp.test(field);
};


const $73936c209f170d43$export$9828a7bc523db331 = async function() {
    // imitate response time
    try {
        await $73936c209f170d43$var$_sleep(300);
    } catch (error) {
        console.error(`Error while waiting for the response: ${error}`);
        throw error;
    }
    // execute request
    return $73936c209f170d43$var$_getAllMenusFromData();
};
const $73936c209f170d43$export$7c6e2bbe4e54360c = async function() {
    // imitate response time
    try {
        await $73936c209f170d43$var$_sleep(400);
    } catch (error) {
        console.error(`Error while waiting for the response: ${error}`);
        throw error;
    }
    // execute request
    return $73936c209f170d43$var$_getAllSingleItemsFromData();
};
const $73936c209f170d43$export$1aaf3b39f64c63de = async function(type) {
    // imitate response time
    try {
        await $73936c209f170d43$var$_sleep(300);
    } catch (error) {
        console.error(`Error while waiting for the response: ${error}`);
        throw error;
    }
    // execute request
    return $73936c209f170d43$var$_getAllSingleItemsFromData().filter((item)=>item.type === type);
};
const $73936c209f170d43$export$15b7d0c192d0aa5d = async function() {
    // imitate response time
    try {
        await $73936c209f170d43$var$_sleep(450);
    } catch (error) {
        console.error(`Error while waiting for the response: ${error}`);
        throw error;
    }
    // execute request
    return $73936c209f170d43$var$_getAllItemsFromData();
};
const $73936c209f170d43$export$cde8ca1b2caa28d = async function(id) {
    // imitate response time
    try {
        await $73936c209f170d43$var$_sleep(100);
    } catch (error) {
        console.error(`Error while waiting for the response: ${error}`);
        throw error;
    }
    // execute request
    return $73936c209f170d43$var$_getAllItemsFromData().find((item)=>item.id === id);
};
const $73936c209f170d43$export$6c5fa4acfd9b4c37 = async function(deliveryAddress) {
    // imitate response time
    try {
        await $73936c209f170d43$var$_sleep(400);
    } catch (error) {
        console.error(`Error while waiting for the response: ${error}`);
        throw error;
    }
    // execute request
    return $c9c3c560c3a94d63$export$6c5fa4acfd9b4c37(deliveryAddress);
};
const $73936c209f170d43$export$ece74c83493b716c = async function(deliveryAddress) {
    // imitate response time
    try {
        await $73936c209f170d43$var$_sleep(500);
    } catch (error) {
        console.error(`Error while waiting for the response: ${error}`);
        throw error;
    }
    // execute request
    return $73936c209f170d43$var$_getDeliveryTime();
};
const $73936c209f170d43$export$2de1c5c9ead290a3 = async function(cart) {
    // imitate response time
    try {
        await $73936c209f170d43$var$_sleep(800);
    } catch (error) {
        console.error(`Error while waiting for the response: ${error}`);
        throw error;
    }
    // return order
    return cart;
};
// ***********************************
// API response placeholder functions:
// ***********************************
const $73936c209f170d43$var$_sleep = (ms)=>{
    const min = ms - ms * 0.25;
    const max = ms + ms * 0.25;
    const randomDelayMs = Math.random() * (max - min) + min;
    return new Promise((resolve)=>setTimeout(resolve, randomDelayMs));
};
const $73936c209f170d43$var$_getAllItemsFromData = function() {
    return [
        ...$73936c209f170d43$var$_getAllMenusFromData(),
        ...$73936c209f170d43$var$_getAllSingleItemsFromData()
    ];
};
const $73936c209f170d43$var$_getAllMenusFromData = function() {
    const { menus: menus } = (0, $aed308ccf2b638b0$export$4051a07651545597);
    return menus.map((menu)=>{
        // find corresponding burger for menu item
        const burger = $73936c209f170d43$var$_getSingleItemById(menu.burger_id);
        if (!burger) return {};
        // map rest data to item
        return {
            id: menu.id,
            type: "menu",
            name: menu.name,
            description: burger.description,
            ingredients: burger.ingredients,
            price: burger.menuPrice,
            new: burger.new,
            tags: [
                ...menu.tags,
                ...burger.tags.filter((tag)=>tag !== "burger")
            ],
            image: burger.image,
            firstPosition: [
                burger
            ],
            secondPosition: $73936c209f170d43$var$_mapPosition(menu.second_position),
            thirdPosition: $73936c209f170d43$var$_mapPosition(menu.third_position),
            fourthPosition: $73936c209f170d43$var$_mapPosition(menu.fourth_position),
            fifthPosition: $73936c209f170d43$var$_mapPosition(menu.fifth_position)
        };
    });
};
const $73936c209f170d43$var$_getAllSingleItemsFromData = function() {
    const { items: items } = (0, $aed308ccf2b638b0$export$4051a07651545597);
    return items.map((item)=>{
        // map item data to item model
        return {
            id: item.id,
            type: item.type,
            name: item.name,
            description: item.description,
            ingredients: item.ingredients,
            price: item.price,
            menuPrice: item.menu_price,
            new: item.new,
            tags: item.tags,
            image: item.image,
            weightGramm: item.weight,
            nutrientsPortion: item.nutrients_per_portion
        };
    });
};
const $73936c209f170d43$var$_mapPosition = function(position) {
    if (!position || !position.items || position.items.length === 0) return undefined;
    return {
        optional: position.optional,
        items: position.items.map((id)=>{
            return $73936c209f170d43$var$_getSingleItemById(id);
        })
    };
};
const $73936c209f170d43$var$_getSingleItemById = function(id) {
    return $73936c209f170d43$var$_getAllSingleItemsFromData().find((item)=>item.id === id);
};
const $73936c209f170d43$var$_getDeliveryTime = function() {
    const minCeiled = Math.ceil((0, $9dfdde2870d5f6f9$export$5b4488fd1e9252aa));
    const maxFloored = Math.floor((0, $9dfdde2870d5f6f9$export$cbea70a2a3c167da));
    return Math.floor(Math.random() * (maxFloored - minCeiled) + minCeiled);
};



const $f381a3c3b9cf5311$export$ca000e230c0caa3e = {
    cart: {},
    saved: []
};
const $f381a3c3b9cf5311$export$1f96ef276f4967ea = function(deliveryAddress) {
    const cart = {
        entries: [],
        totalPrice: 0,
        deliveryCost: 0,
        totalCost: 0,
        deliveryAddress: deliveryAddress ? deliveryAddress : $f381a3c3b9cf5311$export$1cf57537d18bdefc()
    };
    $f381a3c3b9cf5311$export$ca000e230c0caa3e.cart = cart;
    $f381a3c3b9cf5311$var$_persistCart();
    return cart;
};
const $f381a3c3b9cf5311$export$1cf57537d18bdefc = function(addressData) {
    return {
        name: addressData ? addressData.name : "",
        phone: addressData ? addressData.phone : "",
        street: addressData ? addressData.street : "",
        apartment: addressData ? addressData.apartment : "",
        zip: addressData ? addressData.zip : "",
        town: addressData ? addressData.town : "",
        saved: addressData && addressData.saved ? true : false
    };
};
const $f381a3c3b9cf5311$export$576b6dd9d68b37bc = function(headerItem, childItems = []) {
    const cart = $f381a3c3b9cf5311$export$ca000e230c0caa3e.cart;
    const cartEntry = $f381a3c3b9cf5311$var$_createCartEntry(headerItem, cart.entries.length, childItems);
    cart.entries.push(cartEntry);
    cart.totalPrice = $f381a3c3b9cf5311$var$calculateCartTotalPrice(cart);
    cart.deliveryCost = cart.totalPrice >= (0, $9dfdde2870d5f6f9$export$45039f329125d02c) ? 0 : (0, $9dfdde2870d5f6f9$export$40efa604c66968ab);
    cart.totalCost = cart.totalPrice + cart.deliveryCost;
    $f381a3c3b9cf5311$export$ca000e230c0caa3e.cart = cart;
    $f381a3c3b9cf5311$var$_persistCart();
};
const $f381a3c3b9cf5311$export$8551e31cfd3b1e8e = function(entryNumber) {
    const cart = $f381a3c3b9cf5311$export$ca000e230c0caa3e.cart;
    const index = cart.entries.findIndex((entry)=>entry.entryNumber === +entryNumber);
    cart.entries.splice(index, 1);
    cart.totalPrice = $f381a3c3b9cf5311$var$calculateCartTotalPrice(cart);
    cart.deliveryCost = cart.totalPrice >= (0, $9dfdde2870d5f6f9$export$45039f329125d02c) ? 0 : (0, $9dfdde2870d5f6f9$export$40efa604c66968ab);
    cart.totalCost = cart.totalPrice + cart.deliveryCost;
    $f381a3c3b9cf5311$var$_persistCart();
};
const $f381a3c3b9cf5311$export$6c5fa4acfd9b4c37 = async function(deliveryAddress) {
    try {
        return await $73936c209f170d43$export$6c5fa4acfd9b4c37(deliveryAddress);
    } catch (error) {
        console.error(`Error on delivery address validation: ${error}`);
    }
    return [];
};
const $f381a3c3b9cf5311$export$54744964e87fe7d1 = async function(deliveryAddress) {
    try {
        return await $73936c209f170d43$export$ece74c83493b716c(deliveryAddress);
    } catch (error) {
        console.error(`Can't calculate delivery time: ${error}`);
    }
    return -1;
};
const $f381a3c3b9cf5311$export$2de1c5c9ead290a3 = async function(cart) {
    try {
        return await $73936c209f170d43$export$2de1c5c9ead290a3(cart);
    } catch (error) {
        console.error(`Can't place order: ${error}`);
    }
    return {};
};
const $f381a3c3b9cf5311$var$calculateCartTotalPrice = function(cart) {
    const total = cart.entries.map((entry)=>entry.price).reduce((partialSum, a)=>partialSum + a, 0);
    return total;
};
const $f381a3c3b9cf5311$export$488773977679fb92 = async function(itemId) {
    $f381a3c3b9cf5311$export$ca000e230c0caa3e.saved.push(itemId);
    try {
        const item = $f381a3c3b9cf5311$var$_updateItemSavedState(await $73936c209f170d43$export$cde8ca1b2caa28d(itemId));
        item.saved = true;
    } catch (error) {
        console.error(`Can't save item with id: ${itemId}`);
    }
    $f381a3c3b9cf5311$var$_persistSavedItems();
};
const $f381a3c3b9cf5311$export$6c83a5dc99da6a20 = async function(itemId) {
    const index = $f381a3c3b9cf5311$export$ca000e230c0caa3e.saved.findIndex((id)=>id === itemId);
    $f381a3c3b9cf5311$export$ca000e230c0caa3e.saved.splice(index, 1);
    try {
        const item = $f381a3c3b9cf5311$var$_updateItemSavedState(await $73936c209f170d43$export$cde8ca1b2caa28d(itemId));
        item.saved = false;
    } catch (error) {
        console.error(`Can't unsave item with id: ${itemId}`);
    }
    $f381a3c3b9cf5311$var$_persistSavedItems();
};
const $f381a3c3b9cf5311$export$d08f038a2c35d047 = async function() {
    try {
        return $f381a3c3b9cf5311$var$_updateItemsSavedState(await $73936c209f170d43$export$9828a7bc523db331());
    } catch (error) {
        console.error("Can't fetch all menus");
    }
    return [];
};
const $f381a3c3b9cf5311$export$7c6e2bbe4e54360c = async function() {
    try {
        return $f381a3c3b9cf5311$var$_updateItemsSavedState(await $73936c209f170d43$export$7c6e2bbe4e54360c());
    } catch (error) {
        console.error("Can't fetch all single items");
    }
    return [];
};
const $f381a3c3b9cf5311$export$cd23be06ccd86c09 = async function() {
    try {
        return $f381a3c3b9cf5311$var$_updateItemsSavedState(await $73936c209f170d43$export$1aaf3b39f64c63de("burger"));
    } catch (error) {
        console.error("Can't fetch burger items");
    }
    return [];
};
const $f381a3c3b9cf5311$export$2376c2e6c033c60f = async function() {
    try {
        return $f381a3c3b9cf5311$var$_updateItemsSavedState(await $73936c209f170d43$export$1aaf3b39f64c63de("fingerfood"));
    } catch (error) {
        console.error("Can't fetch fingerfood items");
    }
    return [];
};
const $f381a3c3b9cf5311$export$995b738e7a194809 = async function() {
    try {
        return $f381a3c3b9cf5311$var$_updateItemsSavedState(await $73936c209f170d43$export$1aaf3b39f64c63de("salad"));
    } catch (error) {
        console.error("Can't fetch salad items");
    }
    return [];
};
const $f381a3c3b9cf5311$export$b88cedc81720af31 = async function() {
    try {
        return $f381a3c3b9cf5311$var$_updateItemsSavedState(await $73936c209f170d43$export$1aaf3b39f64c63de("dessert"));
    } catch (error) {
        console.error("Can't fetch dessert items");
    }
    return [];
};
const $f381a3c3b9cf5311$export$881eb403c6d439ae = async function() {
    try {
        return $f381a3c3b9cf5311$var$_updateItemsSavedState(await $73936c209f170d43$export$1aaf3b39f64c63de("drink"));
    } catch (error) {
        console.error("Can't fetch drinks");
    }
    return [];
};
const $f381a3c3b9cf5311$export$fe2d92c6190fd201 = async function() {
    try {
        return $f381a3c3b9cf5311$var$_updateItemsSavedState(await $73936c209f170d43$export$15b7d0c192d0aa5d());
    } catch (error) {
        console.error("Can't fetch all items");
    }
    return [];
};
const $f381a3c3b9cf5311$export$edec868e65d66d9b = async function() {
    try {
        return Promise.all($f381a3c3b9cf5311$export$ca000e230c0caa3e.saved.map(async (id)=>$f381a3c3b9cf5311$var$_updateItemSavedState(await $73936c209f170d43$export$cde8ca1b2caa28d(id))));
    } catch (error) {
        console.error("Can't fetch saved items");
    }
    return [];
};
const $f381a3c3b9cf5311$export$3c1cc9429c2b6cf3 = function() {
    return $f381a3c3b9cf5311$export$ca000e230c0caa3e.cart;
};
const $f381a3c3b9cf5311$export$cde8ca1b2caa28d = async function(id) {
    try {
        return $f381a3c3b9cf5311$var$_updateItemSavedState(await $73936c209f170d43$export$cde8ca1b2caa28d(id));
    } catch (error) {
        console.error(`Can't fetch an item by id: ${id}`);
    }
    return [];
};
const $f381a3c3b9cf5311$var$_updateItemsSavedState = function(items) {
    return items.map((item)=>{
        item.saved = $f381a3c3b9cf5311$export$ca000e230c0caa3e.saved.some((id)=>item.id === id);
        return item;
    });
};
const $f381a3c3b9cf5311$var$_updateItemSavedState = function(item) {
    item.saved = $f381a3c3b9cf5311$export$ca000e230c0caa3e.saved.some((id)=>item.id === id);
    return item;
};
const $f381a3c3b9cf5311$var$_createCartEntry = function(item, entryNumber, childItems = []) {
    return {
        entryNumber: entryNumber,
        item: item,
        childEntries: childItems.length === 0 ? [] : childItems.map((childItem, index)=>$f381a3c3b9cf5311$var$_createCartEntry(childItem, index)),
        price: childItems.length === 0 ? item.price : item.price + childItems.reduce((sum, item)=>sum + item.menuPrice, 0)
    };
};
const $f381a3c3b9cf5311$var$_persistCart = function() {
    localStorage.setItem("cart", JSON.stringify($f381a3c3b9cf5311$export$ca000e230c0caa3e.cart));
};
const $f381a3c3b9cf5311$var$_persistSavedItems = function() {
    localStorage.setItem("saved", JSON.stringify($f381a3c3b9cf5311$export$ca000e230c0caa3e.saved));
};
const $f381a3c3b9cf5311$var$initState = function() {
    const saved = localStorage.getItem("saved");
    if (saved) $f381a3c3b9cf5311$export$ca000e230c0caa3e.saved = JSON.parse(saved);
    const cart = localStorage.getItem("cart");
    $f381a3c3b9cf5311$export$ca000e230c0caa3e.cart = cart ? JSON.parse(cart) : $f381a3c3b9cf5311$export$1f96ef276f4967ea();
};
$f381a3c3b9cf5311$var$initState();


class $979d8bedf0abc0db$export$2e2bcd8739ae039 {
    _data;
    render(data) {
        this._data = data;
        const markup = this._generateMarkup();
        this._clear();
        this._parentElement.insertAdjacentHTML("afterbegin", markup);
    }
    update(data) {
        this._data = data;
        const newMarkup = this._generateMarkup();
        const newDOM = document.createRange().createContextualFragment(newMarkup);
        const newElements = Array.from(newDOM.querySelectorAll("*"));
        const curElements = Array.from(this._parentElement.querySelectorAll("*"));
        newElements.forEach((newEl, i)=>{
            const curEl = curElements[i];
            // Update changed text
            if (!newEl.isEqualNode(curEl) && newEl.firstChild?.nodeValue.trim() !== "") curEl.textContent = newEl.textContent;
            // Update changed attributes
            if (!newEl.isEqualNode(curEl)) Array.from(newEl.attributes).forEach((attr)=>curEl.setAttribute(attr.name, attr.value));
        });
    }
    _clear() {
        this._parentElement.innerHTML = "";
    }
}


class $d7ece041a8872435$export$b2cfc94ea8e228ee extends (0, $979d8bedf0abc0db$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector("#hero");
    _heroMonthElement = document.querySelector("#hero-month");
    addHandlerRender(handler) {
        window.addEventListener("load", handler);
    }
    addHandlerNavigateToItems(handler) {
        const link = this._parentElement.querySelector(".link");
        link.addEventListener("click", function(e) {
            handler(link, undefined, e);
        });
    }
    render(data) {
        this._heroMonthElement.textContent = data;
    }
}
var $d7ece041a8872435$export$2e2bcd8739ae039 = new $d7ece041a8872435$export$b2cfc94ea8e228ee();



const $55e824ff15c161b3$export$6a506b36fdea397d = function(str, n) {
    return str.length > n ? str.slice(0, n - 1) + "&hellip;" : str;
};
const $55e824ff15c161b3$export$c86caf1be068fb8d = function(price) {
    return new Intl.NumberFormat("en-EN", {
        style: "currency",
        currency: "USD"
    }).format(price);
};
const $55e824ff15c161b3$export$5929d4ad317d871a = function(weight) {
    return new Intl.NumberFormat("en-EN", {
        style: "unit",
        unit: "gram"
    }).format(weight);
};
const $55e824ff15c161b3$export$98a3ebfeddd96b65 = function(items) {
    return items.map((item, index)=>{
        if (index !== 0) return item.toLowerCase();
        return item[0].toUpperCase() + item.slice(1).toLowerCase();
    }).join(", ");
};
const $55e824ff15c161b3$export$9bec421b6c37943c = function(item) {
    if (item.type !== "menu") return item.price;
    return $55e824ff15c161b3$export$a1f43b683313f389([
        item.price,
        $55e824ff15c161b3$export$b200c9670d9857a6(item.secondPosition),
        $55e824ff15c161b3$export$b200c9670d9857a6(item.thirdPosition),
        $55e824ff15c161b3$export$b200c9670d9857a6(item.fourthPosition),
        $55e824ff15c161b3$export$b200c9670d9857a6(item.fifthPosition)
    ]);
};
const $55e824ff15c161b3$export$a1f43b683313f389 = function(prices) {
    return prices.reduce((partialSum, price)=>partialSum + price, 0);
};
const $55e824ff15c161b3$export$b200c9670d9857a6 = function(position) {
    if (!position || !position.items || position.items.length === 0 || position.optional) return 0;
    const allPrices = position.items.map((positionItem)=>positionItem.menuPrice);
    return +Math.min(...allPrices);
};
const $55e824ff15c161b3$export$d8cf41a44cdef2e5 = function(itemType) {
    const typeIconMap = new Map();
    typeIconMap.set("burger", "ph-hamburger");
    typeIconMap.set("fingerfood", "ph-popcorn");
    typeIconMap.set("salad", "ph-carrot");
    typeIconMap.set("dessert", "ph-cookie");
    typeIconMap.set("drink", "ph-beer-bottle");
    return typeIconMap.get(itemType);
};
const $55e824ff15c161b3$export$33d2fac105f0918 = function(itemType) {
    const typeNameMap = new Map();
    typeNameMap.set("burger", "Hero Burger");
    typeNameMap.set("fingerfood", "Sidekick");
    typeNameMap.set("salad", "Salad");
    typeNameMap.set("dessert", "Dessert");
    typeNameMap.set("drink", "Drink");
    return typeNameMap.get(itemType);
};
const $55e824ff15c161b3$export$af1211fce2d85d9f = function(positionItems) {
    const allTypes = positionItems.map((positionItem)=>positionItem.type);
    return allTypes.filter(function(type, index) {
        return allTypes.indexOf(type) === index;
    });
};


class $f047d45a919642f2$export$2e2bcd8739ae039 extends (0, $979d8bedf0abc0db$export$2e2bcd8739ae039) {
    _parentElement;
    _itemType;
    addHandlerRender(handler) {
        window.addEventListener("load", handler);
    }
    addHandlerSave(handler) {
        this._parentElement.addEventListener("click", (function(e) {
            const btn = e.target.closest(".btn-save");
            const item = e.target.closest(".item");
            if (!btn || !item) return;
            handler(this, item.id);
        }).bind(this), false);
    }
    addHandlerAddToCart(handler) {
        this._parentElement.addEventListener("click", function(e) {
            const btn = e.target.closest(".btn-primary");
            const item = e.target.closest(".item");
            if (!btn || !item) return;
            handler(item.id);
        });
    }
    addHandlerOpenModalInfo(handler) {
        this._parentElement.addEventListener("click", function(e) {
            const link = e.target.closest(".item-info-modal-link");
            const item = e.target.closest(".item");
            if (!link || !item) return;
            e.preventDefault();
            handler(item.id);
        });
    }
    _generateMarkup() {
        return this._data.filter((item)=>item.type === this._itemType).map((item)=>{
            return this._generateItemMarkup(item);
        }).join("");
    }
    _generateItemMarkup(item) {
        return `
      <div id="${item.id}" class="item ${item.new ? "item-new" : ""}">
        <div class="item-content">
          <div class="item-img-container">
            <div class="ai-image">
              <picture>
                <source
                  srcset="${item.image.medium.webp}"
                  type="image/webp"
                />
                <source
                  srcset="${item.image.medium.jpg}"
                  type="image/jpg"
                />
                <img
                  src="${item.image.medium.webp}"
                  class="item-img"
                  alt="Picture of ${item.name} menu item"
                />
              </picture>
              <span class="ai-label" title="This image was generated with AI">AI-generated image</span>
            </div>
            <a class="item-info-link item-info-modal-link" data-item-id="${item.id}" href="#">
              <i class="ph ph-info"></i>
            </a>
          </div>
          <div class="item-text">
            ${this._generateTagsMarkup(item.tags)}
            <p class="item-title">${item.name}</p>
            ${this._generateDescriptionMarkup(item)}
            ${this._generateAttributesMarkup(item.ingredients)}
          </div>
        </div>
        <div class="item-actions">
          <btn class="btn btn-save ${item.saved ? "btn-save-active" : ""} btn-square">
            <i class="icon ph-fill ph-heart"></i>
          </btn>
          <btn class="btn btn-primary">
            <span>${(0, $55e824ff15c161b3$export$c86caf1be068fb8d)(item.price)}</span>
          </btn>
        </div>
      </div>
    `;
    }
    _generateTagsMarkup(tags) {
        if (tags && tags.length > 0) return `
        <div class="item-tags">
          ${tags.map((tag)=>{
            return this.#generateTagMarkup(tag);
        }).join("")}
        </div>
      `;
        return "";
    }
    #generateTagMarkup(tag) {
        return `
    <div class="tag tag-${tag}">
      <span>${tag}</span>
    </div>
    `;
    }
    _generateDescriptionMarkup(item) {
        let truncatedDescription = item.description;
        if (item.description.length > 40) truncatedDescription = (0, $55e824ff15c161b3$export$6a506b36fdea397d)(item.description, 40);
        return `
    <p class="item-description">
      ${truncatedDescription}
      <a class="link item-info-modal-link" href="#" data-item-id="${item.id}">more</a>
    </p>
    `;
    }
    _generateAttributesMarkup(ingredients) {
        if (ingredients && ingredients.length > 0) return `
        <ul class="item-attributes">
          <li class="item-attribute">
            <i class="icon ph ph-list-bullets"></i>
            <span>
              ${(0, $55e824ff15c161b3$export$98a3ebfeddd96b65)(ingredients)}
            </span>
          </li>
        </ul>
      `;
        return "";
    }
}



class $33f22923bb08d40e$var$SectionMenusView extends (0, $f047d45a919642f2$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector("#menus").querySelector(".section-content");
    _itemType = "menu";
    _generateMarkup() {
        return this._data.filter((item)=>item.type === this._itemType).map((item)=>{
            return this._generateItemMarkup(item);
        }).join("");
    }
    _generateItemMarkup(item) {
        return `
      <div id="${item.id}" class="item ${item.new ? "item-new" : ""}">
        <div class="item-content">
          <div class="item-img-container">
            <div class="ai-image">
              <picture>
                <source
                  srcset="${item.image.large.webp}"
                  type="image/webp"
                />
                <source
                  srcset="${item.image.large.jpg}"
                  type="image/jpg"
                />
                <img
                  src="${item.image.large.webp}"
                  class="item-img"
                  alt="Picture of ${item.name} item"
                />
              </picture>
              <span class="ai-label" title="This image was generated with AI">AI-generated image</span>
            </div>
            <a class="item-info-link item-info-modal-link" href="#">
              <i class="ph ph-info"></i>
            </a>
          </div>
          <div class="item-text">
            ${this._generateTagsMarkup(item.tags)}
            <p class="item-title">${item.name}</p>
            ${this._generateDescriptionMarkup(item)}
            ${this._generateAttributesMarkup(item)}
          </div>
        </div>
        <div class="item-actions">
          <btn class="btn btn-save ${item.saved ? "btn-save-active" : ""} btn-square">
            <i class="icon ph-fill ph-heart"></i>
          </btn>
          <btn class="btn btn-primary">
            <span>From ${(0, $55e824ff15c161b3$export$c86caf1be068fb8d)((0, $55e824ff15c161b3$export$9bec421b6c37943c)(item))}</span>
          </btn>
        </div>
      </div>
    `;
    }
    _generateAttributesMarkup(item) {
        if (item.ingredients && item.ingredients.length > 0) return `
        <ul class="item-attributes">
          <li class="item-attribute">
            <i class="icon ph ph-hamburger"></i>
            <span>
              ${(0, $55e824ff15c161b3$export$98a3ebfeddd96b65)(item.ingredients)}
            </span>
          </li>
          ${this.#generatePositionMarkup(item.secondPosition)}
          ${this.#generatePositionMarkup(item.thirdPosition)}
          ${this.#generatePositionMarkup(item.fourthPosition)}
          ${this.#generatePositionMarkup(item.fifthPosition)}
        </ul>
      `;
        return "";
    }
    #generatePositionMarkup(position) {
        if (!position || !position.items || position.items.length === 0 || position.optional) return "";
        const types = position.items.length === 1 ? [
            position.items[0].type
        ] : (0, $55e824ff15c161b3$export$af1211fce2d85d9f)(position.items);
        const iconName = (0, $55e824ff15c161b3$export$d8cf41a44cdef2e5)(types[0]);
        const positionNames = position.items.length === 1 ? [
            position.items[0].name
        ] : types.map((type)=>(0, $55e824ff15c161b3$export$33d2fac105f0918)(type));
        const positionNameString = positionNames.length > 1 ? positionNames.join(" or ") : positionNames[0];
        return `
      <li class="item-attribute">
        <i class="icon ph ${iconName}"></i>
        <span>${positionNameString}</span>
      </li>
    `;
    }
}
var $33f22923bb08d40e$export$2e2bcd8739ae039 = new $33f22923bb08d40e$var$SectionMenusView();



class $cf92148ebd37dcb9$var$SectionBurgersView extends (0, $f047d45a919642f2$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector("#burgers").querySelector(".section-content");
    _itemType = "burger";
}
var $cf92148ebd37dcb9$export$2e2bcd8739ae039 = new $cf92148ebd37dcb9$var$SectionBurgersView();



class $db67ffb8ac817224$var$SectionFingerfoodView extends (0, $f047d45a919642f2$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector("#fingerfood").querySelector(".section-content");
    _itemType = "fingerfood";
}
var $db67ffb8ac817224$export$2e2bcd8739ae039 = new $db67ffb8ac817224$var$SectionFingerfoodView();



class $32c72e164fa0ffb4$var$SectionSaladsView extends (0, $f047d45a919642f2$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector("#salads").querySelector(".section-content");
    _itemType = "salad";
}
var $32c72e164fa0ffb4$export$2e2bcd8739ae039 = new $32c72e164fa0ffb4$var$SectionSaladsView();



class $cc4198d81abbd27a$var$SectionDessertsView extends (0, $f047d45a919642f2$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector("#desserts").querySelector(".section-content");
    _itemType = "dessert";
}
var $cc4198d81abbd27a$export$2e2bcd8739ae039 = new $cc4198d81abbd27a$var$SectionDessertsView();



class $0ca28dfed5136daa$var$SectionDrinksView extends (0, $f047d45a919642f2$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector("#drinks").querySelector(".section-content");
    _itemType = "drink";
}
var $0ca28dfed5136daa$export$2e2bcd8739ae039 = new $0ca28dfed5136daa$var$SectionDrinksView();



class $6f5b4cf046116258$export$932b2bc990d62fc5 extends (0, $979d8bedf0abc0db$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".header");
    addHandlerNavigateToSections(handler) {
        const linksToHandle = [
            ...this._parentElement.querySelectorAll(".main-nav-link"),
            this._parentElement.querySelector(".header-logo-link")
        ];
        linksToHandle.forEach((link)=>{
            link.addEventListener("click", (function(e) {
                handler(link, this._parentElement, e);
            }).bind(this), false);
        });
    }
    addHandlerMobileNav(handler) {
        const btnNavElement = document.querySelector(".btn-mobile-nav");
        btnNavElement.addEventListener("click", (function() {
            handler(this._parentElement);
        }).bind(this), false);
    }
    changeSavedItemsIcon(isFill) {
        const iconSavedEmptyEl = document.querySelector(".icon-saved-empty");
        const iconSavedFillEl = document.querySelector(".icon-saved-non-empty");
        if (isFill && !iconSavedEmptyEl.classList.contains("hidden")) {
            iconSavedEmptyEl.classList.add("hidden");
            iconSavedFillEl.classList.remove("hidden");
        }
        if (!isFill && !iconSavedFillEl.classList.contains("hidden")) {
            iconSavedFillEl.classList.add("hidden");
            iconSavedEmptyEl.classList.remove("hidden");
        }
    }
    changeCartIcon(isFill) {
        const iconCartEmptyEl = document.querySelector(".icon-cart-empty");
        const iconCartFillEl = document.querySelector(".icon-cart-non-empty");
        if (isFill && !iconCartEmptyEl.classList.contains("hidden")) {
            iconCartEmptyEl.classList.add("hidden");
            iconCartFillEl.classList.remove("hidden");
        }
        if (!isFill && !iconCartFillEl.classList.contains("hidden")) {
            iconCartFillEl.classList.add("hidden");
            iconCartEmptyEl.classList.remove("hidden");
        }
    }
    setCartIconCounter(value) {
        const iconCartEl = document.querySelector(".header-icon-cart-counter").innerHTML = value;
    }
}
var $6f5b4cf046116258$export$2e2bcd8739ae039 = new $6f5b4cf046116258$export$932b2bc990d62fc5();



class $c10d849d150516f3$export$af41f29dfb7e37b8 extends (0, $979d8bedf0abc0db$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".footer");
    addHandlerRender(handler) {
        window.addEventListener("load", handler);
    }
    render(data) {
        this._parentElement.querySelector(".footer-year").textContent = data.currentYear;
        this._parentElement.querySelectorAll(".footer-link-replaced").forEach((element)=>element.href = data.linkUrl);
    }
}
var $c10d849d150516f3$export$2e2bcd8739ae039 = new $c10d849d150516f3$export$af41f29dfb7e37b8();



class $a65fb30a09a879f4$export$2e2bcd8739ae039 extends (0, $979d8bedf0abc0db$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".modal-content");
    _modal = document.querySelector(".modal-body");
    _overlay = document.querySelector(".overlay");
    addHandlerCloseModal(handler) {
        const modalCloseBtn = this._modal.querySelector(".close-modal");
        // close on button or overlay click
        [
            modalCloseBtn,
            this._overlay
        ].forEach((element)=>{
            element.addEventListener("click", function() {
                handler();
            });
        });
        // close on Esc keyboard press
        document.addEventListener("keydown", function(e) {
            if (e.key === "Escape") handler();
        });
    }
    open() {
        this._modal.classList.remove("hidden");
        this._overlay.classList.remove("hidden");
    }
    close() {
        this._modal.classList.add("hidden");
        this._overlay.classList.add("hidden");
    }
}



class $748fa7af6644fcf4$var$ItemInfoModalView extends (0, $a65fb30a09a879f4$export$2e2bcd8739ae039) {
    _generateMarkup() {
        return `
      ${this.#generateImageMarkup(this._data.image, this._data.name)}
      <div class="modal-text">
        <h1 class="modal-title">${this._data.name}</h1>
        ${this.#generateDescriptionMarkup(this._data.description)}
        ${this.#generateAttributesMarkup(this._data.ingredients)}
        ${this.#generateNutritionsMarkup(this._data)}
      </div>
    `;
    }
    #generateImageMarkup(image, name) {
        if (!image.original.jpg || !image.original.webp) return "";
        return `
      <div class="ai-image">
        <picture>
          <source
            srcset="${image.original.webp}"
            type="image/webp"
          />
          <source
            srcset="${image.original.jpg}"
            type="image/jpg"
          />
          <img
            src="${image.original.webp}"
            class="modal-img"
            alt="Picture of ${name} menu item"
          />
        </picture>
        <span class="ai-label" title="This image was generated with AI">AI-generated image</span>
      </div>
    `;
    }
    #generateDescriptionMarkup(description) {
        return `
      <p class="modal-description">${description}</p>
    `;
    }
    #generateAttributesMarkup(ingredients) {
        if (ingredients && ingredients.length > 0) return `
        <ul class="item-attributes">
          <li class="item-attribute">
            <i class="icon ph ph-list-bullets"></i>
            <span>
              ${(0, $55e824ff15c161b3$export$98a3ebfeddd96b65)(ingredients)}
            </span>
          </li>
        </ul>
      `;
        return "";
    }
    #generateNutritionsMarkup(item) {
        if (item.weightGramm === undefined || item.nutrientsPortion === undefined) return "";
        return `
    <div class="modal-nutritions">
      <i class="icon ph ph-fire"></i>
      <div>
        <table class="modal-nutritions-table">
          <thead>
            <tr>
              <th>Nutrition table</td>
              <th>Per ${(0, $55e824ff15c161b3$export$5929d4ad317d871a)(100)}</th>
              <th>Per portion (${(0, $55e824ff15c161b3$export$5929d4ad317d871a)(item.weightGramm)})</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <th>Calories</th>
              <td>${item.nutrientsPortion.calories} kcal</td>
              <td>${this.#calculateForPortion(item.nutrientsPortion.calories, item.weightGramm)} kcal</td>
            </tr>
            <tr>
              <th>Protein</th>
              <td>${(0, $55e824ff15c161b3$export$5929d4ad317d871a)(item.nutrientsPortion.protein)}</td>
              <td>${(0, $55e824ff15c161b3$export$5929d4ad317d871a)(this.#calculateForPortion(item.nutrientsPortion.protein, item.weightGramm))}</td>
            </tr>
            <tr>
              <th>Carbohydrates</th>
              <td>${(0, $55e824ff15c161b3$export$5929d4ad317d871a)(item.nutrientsPortion.carbohydrates)}</td>
              <td>${(0, $55e824ff15c161b3$export$5929d4ad317d871a)(this.#calculateForPortion(item.nutrientsPortion.carbohydrates, item.weightGramm))}</td>
            </tr>
            <tr>
              <th>Sugar</th>
              <td>${(0, $55e824ff15c161b3$export$5929d4ad317d871a)(item.nutrientsPortion.sugars)}</td>
              <td>${(0, $55e824ff15c161b3$export$5929d4ad317d871a)(this.#calculateForPortion(item.nutrientsPortion.sugars, item.weightGramm))}</td>
            </tr>
            <tr>
              <th>Fat</th>
              <td>${(0, $55e824ff15c161b3$export$5929d4ad317d871a)(item.nutrientsPortion.fat)}</td>
              <td>${(0, $55e824ff15c161b3$export$5929d4ad317d871a)(this.#calculateForPortion(item.nutrientsPortion.fat, item.weightGramm))}</td>
            </tr>
            <tr>
              <th>Fiber</th>
              <td>${(0, $55e824ff15c161b3$export$5929d4ad317d871a)(item.nutrientsPortion.fiber)}</td>
              <td>${(0, $55e824ff15c161b3$export$5929d4ad317d871a)(this.#calculateForPortion(item.nutrientsPortion.fiber, item.weightGramm))}</td>
            </tr>
            <tr>
              <th>Sodium</th>
              <td>${(0, $55e824ff15c161b3$export$5929d4ad317d871a)(item.nutrientsPortion.sodium)}</td>
              <td>${(0, $55e824ff15c161b3$export$5929d4ad317d871a)(this.#calculateForPortion(item.nutrientsPortion.sodium, item.weightGramm))}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    `;
    }
    #calculateForPortion(weight, portionWeight) {
        return Math.round(weight / 100 * portionWeight * 100) / 100;
    }
}
var $748fa7af6644fcf4$export$2e2bcd8739ae039 = new $748fa7af6644fcf4$var$ItemInfoModalView();




class $fb75207393da2ede$var$MenuConfiguratorModalView extends (0, $a65fb30a09a879f4$export$2e2bcd8739ae039) {
    addListenerSelectPositionItem(handler) {
        [
            ...document.querySelectorAll(".modal-configurator-section-item")
        ].forEach((function(itemEl) {
            itemEl.addEventListener("click", (function() {
                handler(itemEl.id);
            }).bind(this, false));
        }).bind(this), false);
    }
    selectPositionItem(itemId) {
        const currentItemEl = document.querySelector(`#${itemId}`);
        const parentFieldSetEl = currentItemEl.closest(".modal-configurator-section-item-list");
        const selectedItemEl = parentFieldSetEl.querySelector(".selected");
        const optionalFieldSet = parentFieldSetEl.dataset.optional;
        if (currentItemEl === selectedItemEl) {
            if (optionalFieldSet === "true") {
                const selectedItemRadioInputEl = document.querySelector(`#${selectedItemEl.dataset.inputId}`);
                selectedItemRadioInputEl.checked = false;
                selectedItemEl.classList.remove("selected");
            }
            return this.getFormData();
        }
        const currentItemRadioInputEl = document.querySelector(`#${currentItemEl.dataset.inputId}`);
        currentItemRadioInputEl.checked = true;
        currentItemEl.classList.add("selected");
        if (selectedItemEl) {
            const selectedItemRadioInputEl = document.querySelector(`#${selectedItemEl.dataset.inputId}`);
            selectedItemRadioInputEl.checked = false;
            selectedItemEl.classList.remove("selected");
        }
        return this.getFormData();
    }
    getFormData() {
        const formEl = document.querySelector(".modal-configurator-form");
        const dataArr = [
            ...new FormData(formEl)
        ];
        const data = Object.fromEntries(dataArr);
        return data;
    }
    adjustConfigurationPrice(configurationPrice) {
        const configurationPriceEl = document.querySelector(".configuration-price");
        configurationPriceEl.innerHTML = (0, $55e824ff15c161b3$export$c86caf1be068fb8d)(configurationPrice);
    }
    addHandlerConfirmConfiguration(handler) {
        document.querySelector(".modal-configurator-form").addEventListener("submit", function(e) {
            e.preventDefault();
            const dataArr = [
                ...new FormData(this)
            ];
            const data = Object.fromEntries(dataArr);
            handler(data);
        });
    }
    _generateMarkup() {
        const form = this._data;
        return `
      <form class="modal-configurator-form">
        <h1 class="modal-configurator-form-title">Assemble Your <strong class="emph-team">Team</strong></h1>
        <input
         class="modal-configurator-header-input"
         type="text"
         name="menuId"
         value="${form.menuItem.id}"
        />
        <section class="modal-section modal-section-grid">
          <div class="modal-section-icon modal-section-${form.menuItem.type}">
            <i class="ph ph-hamburger"></i>
          </div>
          <div class="modal-section-content">
            ${this.#generateSectionTitleMarkup("Your", "<strong class='emph-burger'>Hero Burger</strong>")}
            <fieldset class="modal-configurator-section-item-list">
              ${this.#generateSectionItemMarkup(form.firstPosition[0], 0, false, "firstPosition", "large")}
            </fieldset>
          </div>
        </section>
        ${this.#generatePositionSectionMarkup(form.secondPosition, form.secondPositionOptional, "secondPosition")}
        ${this.#generatePositionSectionMarkup(form.thirdPosition, form.thirdPositionOptional, "thirdPosition")}
        ${this.#generatePositionSectionMarkup(form.fourthPosition, form.fourthPositionOptional, "fourthPosition")}
        ${this.#generatePositionSectionMarkup(form.fifthPosition, form.fifthPositionOptional, "fifthPosition")}

        <section class="modal-section">
          <div class="modal-actions">
            <button class="btn btn-primary btn-configure">
              Confirm <span class="configuration-price">${(0, $55e824ff15c161b3$export$c86caf1be068fb8d)((0, $55e824ff15c161b3$export$9bec421b6c37943c)(form.menuItem))}</span>
            </button>
          </div>
        </section>
      </form>
    `;
    }
    #generatePositionSectionMarkup(positionItems, optional, positionName) {
        if (!positionItems || positionItems.length === 0) return "";
        const types = positionItems.length === 1 ? positionItems[0].type : (0, $55e824ff15c161b3$export$af1211fce2d85d9f)(positionItems);
        const iconName = (0, $55e824ff15c161b3$export$d8cf41a44cdef2e5)(types[0]);
        let titlePrefix = "";
        if (!optional) titlePrefix = positionItems.length === 1 ? "" : "Choose Your";
        else titlePrefix = "Add Your";
        const titles = positionItems.length === 1 ? positionItems[0].name : types.map((type)=>`<strong class='emph-${type}'>${(0, $55e824ff15c161b3$export$33d2fac105f0918)(type)}</strong>`);
        const titlesString = titles.length > 1 ? titles.join(" or ") : titles[0];
        const size = positionItems.some((item)=>item.ingredients && item.ingredients.length > 0) ? "medium" : "small";
        return `
      <section class="modal-section modal-section-grid"">
        <div class="modal-section-icon modal-section-${types[0]}">
          <i class="ph ${iconName}"></i>
        </div>
        <div class="modal-section-content">
          ${this.#generateSectionTitleMarkup(titlePrefix, titlesString)}
          <fieldset class="modal-configurator-section-item-list children" data-optional="${optional}">
            ${positionItems.map((item, index)=>this.#generateSectionItemMarkup(item, index, optional, positionName, size)).join("")}
          </fieldset>
        </div>
      </section>
    `;
    }
    #generateSectionItemMarkup(item, index, optional, position, size) {
        const selected = optional ? false : index === 0;
        return `
      <div
       id="configurator-item-${item.id}"
       class="modal-configurator-section-item ${size} ${selected ? "selected" : ""}"
       data-input-id="radio-${item.id}">
        ${this.#generateMenuItemImageMarkup(item, size)}
        ${this.#generateMenuItemDescriptionMarkup(item, size)}
      </div>
      <input
       type="radio"
       id="radio-${item.id}"
       name="${position}"
       value="${item.id}"
       ${selected ? "checked" : ""}
      />
    `;
    }
    #generateSectionTitleMarkup(prefix, title) {
        if (!title) return "";
        return `
      <legend class="modal-section-title italic">${prefix} ${title}</legend>
    `;
    }
    #generateMenuItemImageMarkup(item, size) {
        const image = item.image;
        if (!image[size].jpg || !image[size].webp) return "";
        return `
      <div class="ai-image">
        <picture>
          <source
            srcset="${image[size].webp}"
            type="image/webp"
          />
          <source
            srcset="${image[size].jpg}"
            type="image/jpg"
          />
          <img
            src="${image[size].webp}"
            class="modal-configurator-img ${size}"
            alt="Picture of ${item.name} menu item"
          />
        </picture>
        <span class="ai-label" title="This image was generated with AI">${size === "small" ? "AI" : "AI-generated image"}</span>
      </div>
    `;
    }
    #generateMenuItemDescriptionMarkup(item, size) {
        return `
      <div class="modal-configurator-item-textbox ${size}">
        <div class="modal-configurator-item-textbox-left ${size}">
          <h1 class="modal-configurator-item-title ${size}">${item.name}</h1>
          ${this.#generateAttributesMarkup(item.ingredients, size)}
        </div>
        <div class="modal-configurator-item-textbox-right ${size}">
          <h1 class="modal-configurator-item-title ${size}">${(0, $55e824ff15c161b3$export$c86caf1be068fb8d)(item.menuPrice)}</h1>
        </div>
      </div>
    `;
    }
    #generateAttributesMarkup(ingredients, size) {
        if (ingredients && ingredients.length > 0) return `
        <ul class="modal-configurator-item-attributes">
          <li class="modal-configurator-item-attribute ${size}">
            <i class="icon ph ph-list-bullets"></i>
            <span>
              ${(0, $55e824ff15c161b3$export$98a3ebfeddd96b65)(ingredients)}
            </span>
          </li>
        </ul>
      `;
        return "";
    }
}
var $fb75207393da2ede$export$2e2bcd8739ae039 = new $fb75207393da2ede$var$MenuConfiguratorModalView();





class $1adcf34f24390fe8$var$CheckoutModalView extends (0, $a65fb30a09a879f4$export$2e2bcd8739ae039) {
    addHandlerPlaceOrder(handler) {
        document.querySelector(".modal-checkout-form").addEventListener("submit", function(e) {
            e.preventDefault();
            const dataArr = [
                ...new FormData(this)
            ];
            const data = Object.fromEntries(dataArr);
            handler(data);
        });
    }
    _generateMarkup() {
        const cart = this._data.cart;
        const deliveryAddress = cart.deliveryAddress;
        const invalidFields = this._data.invalidFields;
        return `
      <form class="modal-checkout-form">
        <section class="modal-section modal-section-grid">
          <div class="modal-section-icon">
            <i class="ph ph-map-pin"></i>
          </div>
          <div class="modal-section-content">
            <h2 class="modal-section-title">Delivery Address</h2>
            <div>
              <div class="checkout-address-grid">
                <div class="modal-checkout-text-input-group">
                  <label for="name" class="mandatory">Name*</label>
                  <input
                    id="name"
                    class="modal-checkout-text-input ${invalidFields.includes("name") ? "invalid" : ""}"
                    placeholder="John Smith"
                    value="${deliveryAddress.name}"
                    name="name"
                    type="text"
                    autocomplete="off"
                    required
                    pattern="${0, $9dfdde2870d5f6f9$export$9d2732c5dba079a3}"
                  />
                </div>
                <div class="modal-checkout-text-input-group">
                  <label for="phone" class="mandatory">Phone*</label>
                  <input
                    id="phone"
                    class="modal-checkout-text-input ${invalidFields.includes("phone") ? "invalid" : ""}"
                    placeholder="555-123-4567"
                    value="${deliveryAddress.phone}"
                    name="phone"
                    type="text"
                    autocomplete="off"
                    required
                    pattern="${0, $9dfdde2870d5f6f9$export$c924649278fd1cb6}"
                  />
                </div>
                <div class="modal-checkout-text-input-group">
                  <label for="street" class="mandatory">Street*</label>
                  <input
                    id="street"
                    class="modal-checkout-text-input ${invalidFields.includes("street") ? "invalid" : ""}"
                    placeholder="8850 Santa Monica Blvd"
                    value="${deliveryAddress.street}"
                    name="street"
                    type="text"
                    autocomplete="off"
                    required
                    pattern="${0, $9dfdde2870d5f6f9$export$c9d018dd9cdc54a3}"
                  />
                </div>
                <div class="modal-checkout-text-input-group">
                  <label for="apartment">Apartment, suite, etc.</label>
                  <input
                    id="apartment"
                    class="modal-checkout-text-input ${invalidFields.includes("apartment") ? "invalid" : ""}"
                    placeholder="12-a"
                    value="${deliveryAddress.apartment}"
                    name="apartment"
                    type="text"
                    autocomplete="off"
                    pattern="${0, $9dfdde2870d5f6f9$export$96cb3daae875a04d}"
                  />
                </div>
                <div class="modal-checkout-text-input-group">
                  <label for="zip" class="mandatory">Postcode*</label>
                  <input
                    id="zip"
                    class="modal-checkout-text-input ${invalidFields.includes("zip") ? "invalid" : ""}"
                    placeholder="90069"
                    value="${deliveryAddress.zip}"
                    name="zip"
                    type="text"
                    autocomplete="off"
                    required
                    pattern="${0, $9dfdde2870d5f6f9$export$baf0e4b816c68eb1}"
                  />
                </div>
                <div class="modal-checkout-text-input-group">
                  <label for="town" class="mandatory">Town*</label>
                  <input
                    id="town"
                    class="modal-checkout-text-input ${invalidFields.includes("town") ? "invalid" : ""}"
                    placeholder="West Hollywood"
                    value="${deliveryAddress.town}"
                    name="town"
                    type="text"
                    autocomplete="off"
                    required
                    pattern="${0, $9dfdde2870d5f6f9$export$b85bbe1c93b6745e}"
                  />
                </div>
                <div class="modal-checkout-checkbox-input-group">
                  <input
                    id="saved"
                    name="saved"
                    type="checkbox"
                    ${deliveryAddress.saved ? "checked" : ""}
                  />
                  <label for="saved">Save for future orders</label>
                </div>
              </div>
              <p class="modal-checkout-disclaimer">*Required fields</p>
            </div>
          </div>

        </section>

        <section class="modal-section modal-section-grid">
          <div class="modal-section-icon">
            <i class="ph ph-list-checks"></i>
          </div>
          <div class="modal-section-content">
            <h2 class="modal-section-title">Order Details</h2>
            <div>
              ${this.#generateEntryListMarkup(cart.entries)}
              ${this.#generateTotalsMarkup(cart)}
            </div>
          </div>
        </section>

        <section class="modal-section">
          <div class="modal-actions">
            <button class="btn btn-primary btn-place-order">
              <span>Place order</span>
            </button>
          </div>
        </section>
      </form>
    `;
    }
    #generateEntryListMarkup(entries) {
        return `
      <ul class="modal-checkout-entries-list">
        ${entries.map((entry)=>this.#generateEntryMarkup(entry)).join("")}
      </ul>
    `;
    }
    #generateEntryMarkup(entry) {
        return `
      <li class="modal-checkout-entries-list-item">
        <div class="ai-image">
          <picture>
            <source
              srcset="${entry.item.image.small.webp}"
              type="image/webp"
            />
            <source
              srcset="${entry.item.image.small.jpg}"
              type="image/jpg"
            />
            <img
              src="${entry.item.image.small.webp}"
              class="modal-checkout-item-img"
              alt="Picture of ${entry.item.name} in checkout summary"
            />
          </picture>
          <span class="ai-label" title="This image was generated with AI">AI</span>
        </div>
        <div class="modal-checkout-item-text">
          <p class="modal-checkout-item-name">${entry.item.name}</p>
          ${this.#generateChildEntriesListMarkup(entry.childEntries)}
        </div>
        <div class="modal-checkout-item-price">
          ${(0, $55e824ff15c161b3$export$c86caf1be068fb8d)(entry.price)}
        </div>
      </li>
    `;
    }
    #generateChildEntriesListMarkup(childEntries) {
        return `
      <ul class="modal-checkout-item-children">
        ${childEntries.map((childEntry)=>{
            return `
            <li class="modal-checkout-item-child">
              &ndash;&nbsp;${childEntry.item.name}
            </li>
          `;
        }).join("")}
      </ul>
    `;
    }
    #generateTotalsMarkup(cart) {
        return `
      <div class="modal-checkout-totals">
        <p class="modal-checkout-price-text">
          <span>Total price:</span>
          <span>${(0, $55e824ff15c161b3$export$c86caf1be068fb8d)(cart.totalPrice)}</span>
        </p>
        <p class="modal-checkout-price-text">
          <span>Delivery cost:</span>
          <span>${(0, $55e824ff15c161b3$export$c86caf1be068fb8d)(cart.deliveryCost)}</span>
        </p>
        <p class="modal-checkout-price-text total">
          <span>Total cost:</span>
          <span>${(0, $55e824ff15c161b3$export$c86caf1be068fb8d)(cart.totalCost)}</span>
        </p>
      </div>
    `;
    }
}
var $1adcf34f24390fe8$export$2e2bcd8739ae039 = new $1adcf34f24390fe8$var$CheckoutModalView();



class $4766df95f322a627$var$OrderPlacedModalView extends (0, $a65fb30a09a879f4$export$2e2bcd8739ae039) {
    _generateMarkup() {
        return `
      <div class="modal-text">
        <h1 class="modal-order-placed-title">Your order is successful!</h1>
        <p class="modal-order-placed-description">
          Estimated delivery time is <span class="modal-order-placed-time">${this._data.deliveryTime} minutes</span>
        </p>
        <div class="modal-order-placed-picture">
          <i class="ph ph-confetti"></i>
        </div>
      </div>
    `;
    }
}
var $4766df95f322a627$export$2e2bcd8739ae039 = new $4766df95f322a627$var$OrderPlacedModalView();



class $d8b706e4e7607954$var$LoaderModalView extends (0, $a65fb30a09a879f4$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector("#loader");
    _wheel = this._parentElement.querySelector(".loader-wheel");
    _overlay = this._parentElement.querySelector(".loader-overlay");
    render(data) {
        this._wheel.classList.remove("hidden");
        this._overlay.classList.remove("hidden");
    }
    clear() {
        this._wheel.classList.add("hidden");
        this._overlay.classList.add("hidden");
    }
}
var $d8b706e4e7607954$export$2e2bcd8739ae039 = new $d8b706e4e7607954$var$LoaderModalView();



class $a9e4b92dec088d06$export$2e2bcd8739ae039 extends (0, $979d8bedf0abc0db$export$2e2bcd8739ae039) {
    _parentElement = document.querySelector(".side-panel");
    _actionBtn;
    addHandlerRender(handler) {
        this._actionBtn.addEventListener("click", function() {
            handler();
        });
    }
    addHandlerClose(handler) {
        // close on button click
        const sidePanelCloseBtn = this._parentElement.querySelector(".close-side-panel");
        sidePanelCloseBtn.addEventListener("click", function() {
            handler();
        });
        // close on Esc keyboard press
        document.addEventListener("keydown", function(e) {
            if (e.key === "Escape") handler();
        });
        // close on outside click
        document.body.addEventListener("click", (function(e) {
            if ((!e.target.closest(".btn-header-panel") || !e.target.closest(".btn-header-panel") === this._actionBtn) && !e.target.closest(".side-panel-body") && this.#getSidePanelBody()) handler();
        }).bind(this), false);
    }
    render(data) {
        super.render(data);
        this.show();
    }
    show() {
        this.#getSidePanelBody().classList.remove("hidden");
    }
    hide() {
        this.#getSidePanelBody().classList.add("hidden");
    }
    _generateMarkup() {
        const items = this._extractItems(this._data);
        return `
      <div class="side-panel-body hidden">
        <button class="close-side-panel">
          <i class="ph ph-x"></i>
        </button>
        <div class="side-panel-content">
          ${this._generatePanelHeader()}
          ${this.#generateListMarkup(items)}
          ${this._generatePanelBottomMarkup(this._data)}
          ${this._generatePanelActions(this._data)}
        </div>
      </div>
    `;
    }
    _generatePanelHeader() {
        return "";
    }
    _generatePanelBottomMarkup(data) {
        return "";
    }
    _generatePanelActions(data) {
        return "";
    }
    #generateListMarkup(items) {
        if (items.length === 0) return this._generateEmptyListMarkup();
        return `
      <ul class="side-panel-list">
        ${items.map((item)=>this._generateItemMarkup(item)).join("")}
      </ul>
    `;
    }
    #getSidePanelBody() {
        return this._parentElement.querySelector(".side-panel-body");
    }
}


class $e08bf0e676929384$var$SavedItemsView extends (0, $a9e4b92dec088d06$export$2e2bcd8739ae039) {
    _actionBtn = document.querySelector(".btn-header-panel-saved");
    _navigationHandler;
    _removalHandler;
    addHandlerRender(handler) {
        this._actionBtn.addEventListener("click", function() {
            handler();
        });
    }
    addHandlerNavigateItem(handler) {
        document.querySelectorAll(".side-panel-list-item-nav-link").forEach((item)=>{
            item.addEventListener("click", function(e) {
                handler(item.dataset.itemId);
            });
        });
    }
    addHandlerRemoveItem(handler) {
        document.querySelectorAll(".btn-panel-remove").forEach((item)=>{
            item.addEventListener("click", function() {
                handler(item.dataset.itemId);
            });
        });
    }
    _extractItems(data) {
        return data ? data : [];
    }
    _generateItemMarkup(item) {
        return `
      <li class="side-panel-list-item small">
        <div class="side-panel-list-item-content side-panel-list-item-nav-link" data-item-id="${item.id}">
          <div class="ai-image">
            <picture>
              <source
                srcset="${item.image.small.webp}"
                type="image/webp"
              />
              <source
                srcset="${item.image.small.jpg}"
                type="image/jpg"
              />
              <img
                src="${item.image.small.webp}"
                class="side-panel-item-img"
                alt="Picture of ${item.name} in saved items list"
              />
            </picture>
            <span class="ai-label" title="This image was generated with AI">AI</span>
          </div>
          <div class="side-panel-item-textbox">
            <p class="side-panel-item-text">${item.name}</p>
          </div>
        </div>
        <button class="btn btn-panel-remove" data-item-id="${item.id}">
          <i class="icon ph ph-trash-simple"></i>
        </button>
      </li>
    `;
    }
    _generateEmptyListMarkup() {
        return `
      <div class="side-panel-textbox">
        <div class="side-panel-header-icon">
          <i class="ph ph-heart"></i>
        </div>
        <p class="side-panel-empty-text">
          Save your <span class="side-panel-text-emphasize saved">Favorites</span> here!
        </p>
      </div>
    `;
    }
}
var $e08bf0e676929384$export$2e2bcd8739ae039 = new $e08bf0e676929384$var$SavedItemsView();





class $b1a9a44f5e8e62c9$var$MiniCartView extends (0, $a9e4b92dec088d06$export$2e2bcd8739ae039) {
    _actionBtn = document.querySelector(".btn-header-panel-cart");
    addHandlerRemoveCartEntry(handler) {
        document.querySelectorAll(".btn-panel-remove").forEach((item)=>{
            item.addEventListener("click", function() {
                handler(item.dataset.entryNumber);
            });
        });
    }
    addHandlerCheckoutModal(handler) {
        document.querySelector(".btn-checkout")?.addEventListener("click", function() {
            handler();
        });
    }
    _extractItems(data) {
        return data.entries;
    }
    _generateItemMarkup(entry) {
        const item = entry.item;
        return `
      <li class="side-panel-list-item large">
        <div class="side-panel-list-item-content">
          <div class="ai-image">
            <picture>
              <source
                srcset="${item.image.small.webp}"
                type="image/webp"
              />
              <source
                srcset="${item.image.small.jpg}"
                type="image/jpg"
              />
              <img
                src="${item.image.small.webp}"
                class="side-panel-item-img"
                alt="Picture of ${item.name} in cart entry"
              />
            </picture>
            <span class="ai-label" title="This image was generated with AI">AI</span>
          </div>
          <div class="side-panel-item-textbox">
            <p class="side-panel-item-text">${item.name}</p>
            ${this.#generateChildEntriesListMarkup(entry.childEntries)}
            <p class="side-panel-item-price">
              ${(0, $55e824ff15c161b3$export$c86caf1be068fb8d)(entry.price)}
            </p>
          </div>
        </div>
        <button class="btn btn-panel-remove" data-entry-number="${entry.entryNumber}">
          <i class="icon ph ph-trash-simple"></i>
        </button>
      </li>
    `;
    }
    #generateChildEntriesListMarkup(childEntries) {
        return `
      <ul class="side-panel-item-children">
        ${childEntries.map((childEntry)=>{
            return `
            <li class="side-panel-item-child">
              &ndash;&nbsp;${childEntry.item.name}
            </li>
          `;
        }).join("")}
      </ul>
    `;
    }
    _generatePanelBottomMarkup(cart) {
        if (cart.totalPrice === 0) return "";
        return `
      <div class="side-panel-textbox">
        <div class="side-panel-header-icon background">
          <i class="ph ph-shopping-cart-simple"></i>
        </div>
        <p class="side-panel-price-text">
          <span>Total price:</span>
          <span>${(0, $55e824ff15c161b3$export$c86caf1be068fb8d)(cart.totalPrice)}</span>
        </p>
        <p class="side-panel-price-text">
          <span>Delivery cost*:</span>
          <span>${(0, $55e824ff15c161b3$export$c86caf1be068fb8d)(cart.deliveryCost)}</span>
        </p>
        <p class="side-panel-price-text total">
          <span>Total cost:</span>
          <span>${(0, $55e824ff15c161b3$export$c86caf1be068fb8d)(cart.totalCost)}</span>
        </p>
        <p class="side-panel-disclaimer">
          *Free delivery for a total price of more than ${(0, $55e824ff15c161b3$export$c86caf1be068fb8d)((0, $9dfdde2870d5f6f9$export$45039f329125d02c))}
        </p>
      </div>
    `;
    }
    _generatePanelActions(cart) {
        if (cart.totalPrice === 0) return "";
        return `
      <div class="side-panel-actions">
        <button class="btn btn-primary btn-checkout">Checkout</button>
      </div>
    `;
    }
    _generateEmptyListMarkup() {
        return `
      <div class="side-panel-textbox">
        <div class="side-panel-header-icon">
          <i class="ph ph-shopping-cart-simple"></i>
        </div>
        <p class="side-panel-empty-text">
          Add your <span class="side-panel-text-emphasize cart">Hero</span> meal here!
        </p>
      </div>
    `;
    }
}
var $b1a9a44f5e8e62c9$export$2e2bcd8739ae039 = new $b1a9a44f5e8e62c9$var$MiniCartView();




const $03cf872f16b5d10b$var$sectionItemsViewList = [
    (0, $33f22923bb08d40e$export$2e2bcd8739ae039),
    (0, $cf92148ebd37dcb9$export$2e2bcd8739ae039),
    (0, $db67ffb8ac817224$export$2e2bcd8739ae039),
    (0, $32c72e164fa0ffb4$export$2e2bcd8739ae039),
    (0, $cc4198d81abbd27a$export$2e2bcd8739ae039),
    (0, $0ca28dfed5136daa$export$2e2bcd8739ae039)
];
const $03cf872f16b5d10b$var$sectionHeroElement = document.querySelector(".section-hero");
// Sticky navigation
const $03cf872f16b5d10b$var$observer = new IntersectionObserver(function(entries) {
    const entry = entries[0];
    if (!entry.isIntersecting) document.body.classList.add("sticky");
    else document.body.classList.remove("sticky");
}, {
    // in the viewport
    root: null,
    threshold: 0,
    rootMargin: "-80px"
});
$03cf872f16b5d10b$var$observer.observe($03cf872f16b5d10b$var$sectionHeroElement);
/**
 * Controls rendering of the hero section.
 */ const $03cf872f16b5d10b$var$controlSectionHeroRender = function() {
    const currentMonth = new Date().toLocaleString("en", {
        month: "long"
    });
    (0, $d7ece041a8872435$export$2e2bcd8739ae039).render(currentMonth);
};
/**
 * Controls rendering of the menus section.
 */ const $03cf872f16b5d10b$var$controlSectionMenusRender = async function() {
    try {
        (0, $33f22923bb08d40e$export$2e2bcd8739ae039).render(await $f381a3c3b9cf5311$export$d08f038a2c35d047());
    } catch (error) {
        console.error(`Error: ${error}`);
    }
};
/**
 * Controls rendering of the burgers section.
 */ const $03cf872f16b5d10b$var$controlSectionBurgersRender = async function() {
    try {
        (0, $cf92148ebd37dcb9$export$2e2bcd8739ae039).render(await $f381a3c3b9cf5311$export$cd23be06ccd86c09());
    } catch (error) {
        console.error(`Error: ${error}`);
    }
};
/**
 * Controls rendering of the fingerfood section.
 */ const $03cf872f16b5d10b$var$controlSectionFingerfoodRender = async function() {
    try {
        (0, $db67ffb8ac817224$export$2e2bcd8739ae039).render(await $f381a3c3b9cf5311$export$2376c2e6c033c60f());
    } catch (error) {
        console.error(`Error: ${error}`);
    }
};
/**
 * Controls rendering of the salads section.
 */ const $03cf872f16b5d10b$var$controlSectionSaladsRender = async function() {
    try {
        (0, $32c72e164fa0ffb4$export$2e2bcd8739ae039).render(await $f381a3c3b9cf5311$export$995b738e7a194809());
    } catch (error) {
        console.error(`Error: ${error}`);
    }
};
/**
 * Controls rendering of the desserts section.
 */ const $03cf872f16b5d10b$var$controlSectionDessertsRender = async function() {
    try {
        (0, $cc4198d81abbd27a$export$2e2bcd8739ae039).render(await $f381a3c3b9cf5311$export$b88cedc81720af31());
    } catch (error) {
        console.error(`Error: ${error}`);
    }
};
/**
 * Controls rendering of the drinks section.
 */ const $03cf872f16b5d10b$var$controlSectionDrinksRender = async function() {
    try {
        (0, $0ca28dfed5136daa$export$2e2bcd8739ae039).render(await $f381a3c3b9cf5311$export$881eb403c6d439ae());
    } catch (error) {
        console.error(`Error: ${error}`);
    }
};
/**
 * Controls rendering of the footer.
 */ const $03cf872f16b5d10b$var$controlFooterRender = function() {
    const currentYear = new Date().getFullYear();
    (0, $c10d849d150516f3$export$2e2bcd8739ae039).render({
        currentYear: currentYear,
        linkUrl: (0, $9dfdde2870d5f6f9$export$702dd1129c4aa79)
    });
};
/**
 * Controls scrolling for the navigation links.
 */ const $03cf872f16b5d10b$var$controlNavLinks = function(link, headerEl, event) {
    event.preventDefault();
    const href = link.getAttribute("href");
    // scroll back to top
    if (href === "#") window.scrollTo({
        top: 0,
        behavior: "smooth"
    });
    // scroll to other sections
    if (href !== "#" && href.startsWith("#")) $03cf872f16b5d10b$var$scrollToElement(href);
    // close mobile nav
    if (headerEl && (link.classList.contains("main-nav-link") || link.classList.contains("btn-header-action"))) $03cf872f16b5d10b$var$controlMobileNavToggle(headerEl);
};
const $03cf872f16b5d10b$var$scrollToElement = function(id) {
    const sectionEl = document.querySelector(id);
    if (!sectionEl) return;
    const headerOffset = 96;
    const position = sectionEl.getBoundingClientRect().top;
    const offsetPosition = position + window.scrollY - headerOffset;
    window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
    });
};
/**
 * Controls displaying of the mobile navigation menu.
 */ const $03cf872f16b5d10b$var$controlMobileNavToggle = function(headerEl) {
    headerEl.classList.toggle("nav-open");
};
/**
 * Controls closing of the modal window.
 */ const $03cf872f16b5d10b$var$controlModalClose = function() {
    (0, $748fa7af6644fcf4$export$2e2bcd8739ae039).close();
};
/**
 * Controls opening of the item info modal window.
 */ const $03cf872f16b5d10b$var$controlItemInfoModal = async function(itemId) {
    try {
        const item = await $f381a3c3b9cf5311$export$cde8ca1b2caa28d(itemId);
        (0, $748fa7af6644fcf4$export$2e2bcd8739ae039).open();
        (0, $748fa7af6644fcf4$export$2e2bcd8739ae039).render(item);
    } catch (error) {
        console.error(`Error: ${error}`);
    }
};
/**
 * Controls saving an item.
 */ const $03cf872f16b5d10b$var$controlSaveItem = async function(view, itemId) {
    try {
        // save/unsave item
        if ($f381a3c3b9cf5311$export$ca000e230c0caa3e.saved.length === 0 || !$f381a3c3b9cf5311$export$ca000e230c0caa3e.saved.some((id)=>itemId === id)) await $f381a3c3b9cf5311$export$488773977679fb92(itemId);
        else await $f381a3c3b9cf5311$export$6c83a5dc99da6a20(itemId);
        // update view
        view.update(await $f381a3c3b9cf5311$export$fe2d92c6190fd201());
        // update favorites list icon
        (0, $6f5b4cf046116258$export$2e2bcd8739ae039).changeSavedItemsIcon($f381a3c3b9cf5311$export$ca000e230c0caa3e.saved.length !== 0);
    } catch (error) {
        console.error(`Error: ${error}`);
    }
};
/**
 * Controls add to cart operation.
 */ const $03cf872f16b5d10b$var$controlAddToCart = async function(itemId) {
    try {
        // fetch the item
        const item = await $f381a3c3b9cf5311$export$cde8ca1b2caa28d(itemId);
        // perform add to cart operation
        $f381a3c3b9cf5311$export$576b6dd9d68b37bc(item);
        // open cart panel
        $03cf872f16b5d10b$var$controlOpenMiniCartPanel();
        // update cart icon
        (0, $6f5b4cf046116258$export$2e2bcd8739ae039).changeCartIcon($f381a3c3b9cf5311$export$ca000e230c0caa3e.cart.entries.length !== 0);
        (0, $6f5b4cf046116258$export$2e2bcd8739ae039).setCartIconCounter($f381a3c3b9cf5311$export$ca000e230c0caa3e.cart.entries.length);
    } catch (error) {
        console.error(`Error: ${error}`);
    }
};
/**
 * Controls opening of the menu configurator modal window.
 */ const $03cf872f16b5d10b$var$controlConfigureMenu = async function(itemId) {
    try {
        const menuItem = await $f381a3c3b9cf5311$export$cde8ca1b2caa28d(itemId);
        (0, $fb75207393da2ede$export$2e2bcd8739ae039).open();
        const form = {
            menuItem: menuItem,
            firstPosition: menuItem.firstPosition,
            secondPosition: menuItem.secondPosition?.items,
            secondPositionOptional: menuItem.secondPosition?.optional,
            thirdPosition: menuItem.thirdPosition?.items,
            thirdPositionOptional: menuItem.thirdPosition?.optional,
            fourthPosition: menuItem.fourthPosition?.items,
            fourthPositionOptional: menuItem.fourthPosition?.optional,
            fifthPosition: menuItem.fifthPosition?.items,
            fifthPositionOptional: menuItem.fifthPosition?.optional
        };
        (0, $fb75207393da2ede$export$2e2bcd8739ae039).render(form);
        (0, $fb75207393da2ede$export$2e2bcd8739ae039).addListenerSelectPositionItem($03cf872f16b5d10b$var$controlSelectPositionItem);
        (0, $fb75207393da2ede$export$2e2bcd8739ae039).addHandlerConfirmConfiguration($03cf872f16b5d10b$var$controlAddToCartMenuItem);
        // set total price for initial configuration
        const menuPrices = [
            menuItem.price,
            $03cf872f16b5d10b$var$getMinimalMenuPositionPrice(menuItem.secondPosition),
            $03cf872f16b5d10b$var$getMinimalMenuPositionPrice(menuItem.thirdPosition),
            $03cf872f16b5d10b$var$getMinimalMenuPositionPrice(menuItem.fourthPosition),
            $03cf872f16b5d10b$var$getMinimalMenuPositionPrice(menuItem.fifthPosition)
        ];
        (0, $fb75207393da2ede$export$2e2bcd8739ae039).adjustConfigurationPrice((0, $55e824ff15c161b3$export$a1f43b683313f389)(menuPrices));
    } catch (error) {
        console.error(`Error: ${error}`);
    }
};
const $03cf872f16b5d10b$var$getMinimalMenuPositionPrice = function(position) {
    return position && !position.optional && position.items && position.items.length > 0 ? position.items[0].menuPrice : 0;
};
/**
 * Controls recalculation of the total price for configured menu item.
 */ const $03cf872f16b5d10b$var$controlSelectPositionItem = async function(itemId) {
    try {
        const configuratorData = (0, $fb75207393da2ede$export$2e2bcd8739ae039).selectPositionItem(itemId);
        // collect configured items
        const headerItem = await $f381a3c3b9cf5311$export$cde8ca1b2caa28d(configuratorData.menuId);
        const childItems = await $03cf872f16b5d10b$var$getConfiguredChildItems(configuratorData);
        // extract menu prices for configured items
        const menuPrices = [
            headerItem.price,
            ...childItems.map((item)=>item.menuPrice)
        ];
        // set total price for adjusted configuration
        (0, $fb75207393da2ede$export$2e2bcd8739ae039).adjustConfigurationPrice((0, $55e824ff15c161b3$export$a1f43b683313f389)(menuPrices));
    } catch (error) {
        console.error(`Error: ${error}`);
    }
};
/**
 * Controls adding configured menu item to the cart.
 */ const $03cf872f16b5d10b$var$controlAddToCartMenuItem = async function(configuratorData) {
    try {
        // close configurator modal
        (0, $fb75207393da2ede$export$2e2bcd8739ae039).close();
        // show loading spinner
        (0, $d8b706e4e7607954$export$2e2bcd8739ae039).render();
        // collect configured items
        const headerItem = await $f381a3c3b9cf5311$export$cde8ca1b2caa28d(configuratorData.menuId);
        const childItems = await $03cf872f16b5d10b$var$getConfiguredChildItems(configuratorData);
        // perform add to cart operation
        $f381a3c3b9cf5311$export$576b6dd9d68b37bc(headerItem, childItems);
        // hide loading spinner
        (0, $d8b706e4e7607954$export$2e2bcd8739ae039).clear();
        // render cart panel
        $03cf872f16b5d10b$var$controlOpenMiniCartPanel();
        // update cart icon
        (0, $6f5b4cf046116258$export$2e2bcd8739ae039).changeCartIcon($f381a3c3b9cf5311$export$ca000e230c0caa3e.cart.entries.length !== 0);
        (0, $6f5b4cf046116258$export$2e2bcd8739ae039).setCartIconCounter($f381a3c3b9cf5311$export$ca000e230c0caa3e.cart.entries.length);
    } catch (error) {
        console.error(`Error: ${error}`);
    }
};
const $03cf872f16b5d10b$var$getConfiguredChildItems = async function(configuratorData) {
    try {
        const secondPositionItem = configuratorData.secondPosition ? await $f381a3c3b9cf5311$export$cde8ca1b2caa28d(configuratorData.secondPosition) : null;
        const thirdPositionItem = configuratorData.thirdPosition ? await $f381a3c3b9cf5311$export$cde8ca1b2caa28d(configuratorData.thirdPosition) : null;
        const fourthPositionItem = configuratorData.fourthPosition ? await $f381a3c3b9cf5311$export$cde8ca1b2caa28d(configuratorData.fourthPosition) : null;
        const fifthPositionItem = configuratorData.fifthPosition ? await $f381a3c3b9cf5311$export$cde8ca1b2caa28d(configuratorData.fifthPosition) : null;
        return [
            ...secondPositionItem ? [
                secondPositionItem
            ] : [],
            ...thirdPositionItem ? [
                thirdPositionItem
            ] : [],
            ...fourthPositionItem ? [
                fourthPositionItem
            ] : [],
            ...fifthPositionItem ? [
                fifthPositionItem
            ] : []
        ];
    } catch (error) {
        console.error(`Error: ${error}`);
    }
};
/**
 * Controls opening of the saved items modal window.
 */ const $03cf872f16b5d10b$var$controlOpenSavedItemsPanel = async function() {
    try {
        (0, $e08bf0e676929384$export$2e2bcd8739ae039).render(await $f381a3c3b9cf5311$export$edec868e65d66d9b());
        (0, $e08bf0e676929384$export$2e2bcd8739ae039).addHandlerClose($03cf872f16b5d10b$var$controlCloseSavedItemsPanel);
        (0, $e08bf0e676929384$export$2e2bcd8739ae039).addHandlerNavigateItem($03cf872f16b5d10b$var$controlNavigateSavedItem);
        (0, $e08bf0e676929384$export$2e2bcd8739ae039).addHandlerRemoveItem($03cf872f16b5d10b$var$controlRemoveSavedItem);
    } catch (error) {
        console.error(`Error: ${error}`);
    }
};
/**
 * Controls closing saved items modal window.
 */ const $03cf872f16b5d10b$var$controlCloseSavedItemsPanel = function() {
    (0, $e08bf0e676929384$export$2e2bcd8739ae039).hide();
};
/**
 * Controls auto-scrolling to the saved item.
 */ const $03cf872f16b5d10b$var$controlNavigateSavedItem = function(id) {
    $03cf872f16b5d10b$var$controlCloseSavedItemsPanel();
    $03cf872f16b5d10b$var$scrollToElement(`#${id}`);
};
/**
 * Controls removing item from the saved list.
 */ const $03cf872f16b5d10b$var$controlRemoveSavedItem = async function(id) {
    try {
        // load item
        const item = await $f381a3c3b9cf5311$export$cde8ca1b2caa28d(id);
        // remove item from saved list
        await $f381a3c3b9cf5311$export$6c83a5dc99da6a20(item.id);
        // re-render saved items panel
        $03cf872f16b5d10b$var$controlOpenSavedItemsPanel();
        // update sections view
        $03cf872f16b5d10b$var$getSectionItemsViewByType(item.type).update(await $f381a3c3b9cf5311$export$fe2d92c6190fd201());
        // update favorites list icon
        (0, $6f5b4cf046116258$export$2e2bcd8739ae039).changeSavedItemsIcon($f381a3c3b9cf5311$export$ca000e230c0caa3e.saved.length !== 0);
    } catch (error) {
        console.error(`Error: ${error}`);
    }
};
/**
 * Controls opening of the cart modal window.
 */ const $03cf872f16b5d10b$var$controlOpenMiniCartPanel = function() {
    (0, $b1a9a44f5e8e62c9$export$2e2bcd8739ae039).render($f381a3c3b9cf5311$export$3c1cc9429c2b6cf3());
    (0, $b1a9a44f5e8e62c9$export$2e2bcd8739ae039).addHandlerClose($03cf872f16b5d10b$var$controlCloseMiniCartPanel);
    (0, $b1a9a44f5e8e62c9$export$2e2bcd8739ae039).addHandlerRemoveCartEntry($03cf872f16b5d10b$var$controlRemoveCartEntry);
    (0, $b1a9a44f5e8e62c9$export$2e2bcd8739ae039).addHandlerCheckoutModal($03cf872f16b5d10b$var$controlCheckoutModal);
};
/**
 * Controls closing cart modal window.
 */ const $03cf872f16b5d10b$var$controlCloseMiniCartPanel = function() {
    (0, $b1a9a44f5e8e62c9$export$2e2bcd8739ae039).hide();
};
/**
 * Controls removing cart entry.
 */ const $03cf872f16b5d10b$var$controlRemoveCartEntry = function(entryNumber) {
    // remove entry from the state
    $f381a3c3b9cf5311$export$8551e31cfd3b1e8e(entryNumber);
    // re-render cart panel
    $03cf872f16b5d10b$var$controlOpenMiniCartPanel();
    // update cart icon
    (0, $6f5b4cf046116258$export$2e2bcd8739ae039).changeCartIcon($f381a3c3b9cf5311$export$ca000e230c0caa3e.cart.entries.length !== 0);
    (0, $6f5b4cf046116258$export$2e2bcd8739ae039).setCartIconCounter($f381a3c3b9cf5311$export$ca000e230c0caa3e.cart.entries.length);
};
/**
 * Controls opening of the checkout modal window.
 */ const $03cf872f16b5d10b$var$controlCheckoutModal = function() {
    (0, $b1a9a44f5e8e62c9$export$2e2bcd8739ae039).hide();
    (0, $1adcf34f24390fe8$export$2e2bcd8739ae039).open();
    (0, $1adcf34f24390fe8$export$2e2bcd8739ae039).render({
        cart: $f381a3c3b9cf5311$export$3c1cc9429c2b6cf3(),
        invalidFields: []
    });
    (0, $1adcf34f24390fe8$export$2e2bcd8739ae039).addHandlerPlaceOrder($03cf872f16b5d10b$var$controlPlaceOrder);
};
/**
 * Controls placing order. Additionally, performs validation and re-creates an empty cart.
 */ const $03cf872f16b5d10b$var$controlPlaceOrder = async function(addressData) {
    try {
        // close checkout modal
        (0, $1adcf34f24390fe8$export$2e2bcd8739ae039).close();
        // show loading spinner
        (0, $d8b706e4e7607954$export$2e2bcd8739ae039).render();
        // populate submitted address
        const cart = $f381a3c3b9cf5311$export$3c1cc9429c2b6cf3();
        const deliveryAddress = $f381a3c3b9cf5311$export$1cf57537d18bdefc(addressData);
        cart.deliveryAddress = deliveryAddress;
        // validate address
        const invalidFields = await $f381a3c3b9cf5311$export$6c5fa4acfd9b4c37(deliveryAddress);
        if (invalidFields && invalidFields.length > 0) {
            (0, $1adcf34f24390fe8$export$2e2bcd8739ae039).open();
            (0, $1adcf34f24390fe8$export$2e2bcd8739ae039).render({
                cart: cart,
                invalidFields: invalidFields
            });
            (0, $1adcf34f24390fe8$export$2e2bcd8739ae039).addHandlerPlaceOrder($03cf872f16b5d10b$var$controlPlaceOrder);
            return;
        }
        // calculate delivery time
        cart.deliveryTime = await $f381a3c3b9cf5311$export$54744964e87fe7d1(deliveryAddress);
        // place order
        const order = await $f381a3c3b9cf5311$export$2de1c5c9ead290a3(cart);
        // hide loading spinner
        (0, $d8b706e4e7607954$export$2e2bcd8739ae039).clear();
        // show order placed modal
        (0, $4766df95f322a627$export$2e2bcd8739ae039).open();
        (0, $4766df95f322a627$export$2e2bcd8739ae039).render(order);
        // create new empty cart
        $f381a3c3b9cf5311$export$1f96ef276f4967ea(cart.deliveryAddress.saved ? cart.deliveryAddress : undefined);
        // update cart icon
        (0, $6f5b4cf046116258$export$2e2bcd8739ae039).changeCartIcon($f381a3c3b9cf5311$export$ca000e230c0caa3e.cart.entries.length !== 0);
        (0, $6f5b4cf046116258$export$2e2bcd8739ae039).setCartIconCounter($f381a3c3b9cf5311$export$ca000e230c0caa3e.cart.entries.length);
    } catch (error) {
        console.error(`Error: ${error}`);
    }
};
const $03cf872f16b5d10b$var$getSectionItemsViewByType = function(type) {
    return $03cf872f16b5d10b$var$sectionItemsViewList.find((view)=>view._itemType === type);
};
/**
 * The main function for populating the page content and assigning additional handlers.
 */ const $03cf872f16b5d10b$var$init = function() {
    // Header view
    (0, $6f5b4cf046116258$export$2e2bcd8739ae039).addHandlerNavigateToSections($03cf872f16b5d10b$var$controlNavLinks);
    (0, $6f5b4cf046116258$export$2e2bcd8739ae039).addHandlerMobileNav($03cf872f16b5d10b$var$controlMobileNavToggle);
    (0, $6f5b4cf046116258$export$2e2bcd8739ae039).changeSavedItemsIcon($f381a3c3b9cf5311$export$ca000e230c0caa3e.saved.length !== 0);
    (0, $6f5b4cf046116258$export$2e2bcd8739ae039).changeCartIcon($f381a3c3b9cf5311$export$ca000e230c0caa3e.cart.entries.length !== 0);
    (0, $6f5b4cf046116258$export$2e2bcd8739ae039).setCartIconCounter($f381a3c3b9cf5311$export$ca000e230c0caa3e.cart.entries.length);
    // Hero view
    (0, $d7ece041a8872435$export$2e2bcd8739ae039).addHandlerRender($03cf872f16b5d10b$var$controlSectionHeroRender);
    (0, $d7ece041a8872435$export$2e2bcd8739ae039).addHandlerNavigateToItems($03cf872f16b5d10b$var$controlNavLinks);
    // Menus section view
    (0, $33f22923bb08d40e$export$2e2bcd8739ae039).addHandlerRender($03cf872f16b5d10b$var$controlSectionMenusRender);
    (0, $33f22923bb08d40e$export$2e2bcd8739ae039).addHandlerSave($03cf872f16b5d10b$var$controlSaveItem);
    (0, $33f22923bb08d40e$export$2e2bcd8739ae039).addHandlerAddToCart($03cf872f16b5d10b$var$controlConfigureMenu);
    (0, $33f22923bb08d40e$export$2e2bcd8739ae039).addHandlerOpenModalInfo($03cf872f16b5d10b$var$controlItemInfoModal);
    // Burgers section view
    (0, $cf92148ebd37dcb9$export$2e2bcd8739ae039).addHandlerRender($03cf872f16b5d10b$var$controlSectionBurgersRender);
    (0, $cf92148ebd37dcb9$export$2e2bcd8739ae039).addHandlerSave($03cf872f16b5d10b$var$controlSaveItem);
    (0, $cf92148ebd37dcb9$export$2e2bcd8739ae039).addHandlerAddToCart($03cf872f16b5d10b$var$controlAddToCart);
    (0, $cf92148ebd37dcb9$export$2e2bcd8739ae039).addHandlerOpenModalInfo($03cf872f16b5d10b$var$controlItemInfoModal);
    // Fingerfood section view
    (0, $db67ffb8ac817224$export$2e2bcd8739ae039).addHandlerRender($03cf872f16b5d10b$var$controlSectionFingerfoodRender);
    (0, $db67ffb8ac817224$export$2e2bcd8739ae039).addHandlerSave($03cf872f16b5d10b$var$controlSaveItem);
    (0, $db67ffb8ac817224$export$2e2bcd8739ae039).addHandlerAddToCart($03cf872f16b5d10b$var$controlAddToCart);
    (0, $db67ffb8ac817224$export$2e2bcd8739ae039).addHandlerOpenModalInfo($03cf872f16b5d10b$var$controlItemInfoModal);
    // Salads section view
    (0, $32c72e164fa0ffb4$export$2e2bcd8739ae039).addHandlerRender($03cf872f16b5d10b$var$controlSectionSaladsRender);
    (0, $32c72e164fa0ffb4$export$2e2bcd8739ae039).addHandlerSave($03cf872f16b5d10b$var$controlSaveItem);
    (0, $32c72e164fa0ffb4$export$2e2bcd8739ae039).addHandlerAddToCart($03cf872f16b5d10b$var$controlAddToCart);
    (0, $32c72e164fa0ffb4$export$2e2bcd8739ae039).addHandlerOpenModalInfo($03cf872f16b5d10b$var$controlItemInfoModal);
    // Desserts section view
    (0, $cc4198d81abbd27a$export$2e2bcd8739ae039).addHandlerRender($03cf872f16b5d10b$var$controlSectionDessertsRender);
    (0, $cc4198d81abbd27a$export$2e2bcd8739ae039).addHandlerSave($03cf872f16b5d10b$var$controlSaveItem);
    (0, $cc4198d81abbd27a$export$2e2bcd8739ae039).addHandlerAddToCart($03cf872f16b5d10b$var$controlAddToCart);
    (0, $cc4198d81abbd27a$export$2e2bcd8739ae039).addHandlerOpenModalInfo($03cf872f16b5d10b$var$controlItemInfoModal);
    // Drinks section view
    (0, $0ca28dfed5136daa$export$2e2bcd8739ae039).addHandlerRender($03cf872f16b5d10b$var$controlSectionDrinksRender);
    (0, $0ca28dfed5136daa$export$2e2bcd8739ae039).addHandlerSave($03cf872f16b5d10b$var$controlSaveItem);
    (0, $0ca28dfed5136daa$export$2e2bcd8739ae039).addHandlerAddToCart($03cf872f16b5d10b$var$controlAddToCart);
    (0, $0ca28dfed5136daa$export$2e2bcd8739ae039).addHandlerOpenModalInfo($03cf872f16b5d10b$var$controlItemInfoModal);
    // Footer view
    (0, $c10d849d150516f3$export$2e2bcd8739ae039).addHandlerRender($03cf872f16b5d10b$var$controlFooterRender);
    // Modal view
    (0, $748fa7af6644fcf4$export$2e2bcd8739ae039).addHandlerCloseModal($03cf872f16b5d10b$var$controlModalClose);
    // Saved items panel view
    (0, $e08bf0e676929384$export$2e2bcd8739ae039).addHandlerRender($03cf872f16b5d10b$var$controlOpenSavedItemsPanel);
    // Cart panel view
    (0, $b1a9a44f5e8e62c9$export$2e2bcd8739ae039).addHandlerRender($03cf872f16b5d10b$var$controlOpenMiniCartPanel);
};
$03cf872f16b5d10b$var$init();


//# sourceMappingURL=index.e6947e15.js.map
